/* ============================================================
   MOVTECH KVÍZ — a bolti faceted szűrőre építve (vanilla JS).
   A válaszok a Shopify metafield-szűrőkre képződnek le, az
   eredmény egy ELŐRE-SZŰRT kollekció-link.
   Facetek: target (Kinek?) · goal (Mi a célod?) ·
            testresz (Testrész) · technologia (Technológia)
   A kvíz MINDEN ágon 7 kérdés: vásárlás típusa, nem, születésnap, cél,
   az ághoz tartozó két al-kérdés, végül a termékválasztó (50% kedvezménnyel melyiket kérné).
   Ez azért kötött, mert minden válasz 500 Ft-ot ér, és a végén mindenki
   ugyanazt a 3 500 Ft-os ajándékutalványt kapja (lásd EGYENLEG-SZÁMLÁLÓ).
   ============================================================ */
const ICONS={"rocket": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z\"/><path d=\"m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z\"/><path d=\"M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0\"/><path d=\"M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5\"/></svg>", "sun": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><circle cx=\"12\" cy=\"12\" r=\"4\" /><path d=\"M12 2v2\" /><path d=\"M12 20v2\" /><path d=\"m4.93 4.93 1.41 1.41\" /><path d=\"m17.66 17.66 1.41 1.41\" /><path d=\"M2 12h2\" /><path d=\"M20 12h2\" /><path d=\"m6.34 17.66-1.41 1.41\" /><path d=\"m19.07 4.93-1.41 1.41\" /></svg>", "flame": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M12 3q1 4 4 6.5t3 5.5a1 1 0 0 1-14 0 5 5 0 0 1 1-3 1 1 0 0 0 5 0c0-2-1.5-3-1.5-5q0-2 2.5-4\" /></svg>", "bandage": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"1.8\" y=\"8\" width=\"20.4\" height=\"8\" rx=\"4\" transform=\"rotate(-45 12 12)\"/><path d=\"M9.5 9.5h.01\"/><path d=\"M14.5 14.5h.01\"/><path d=\"M9.5 14.5h.01\"/><path d=\"M14.5 9.5h.01\"/></svg>", "audio-waveform": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2\" /></svg>", "stethoscope": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M11 2v2\" /><path d=\"M5 2v2\" /><path d=\"M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1\" /><path d=\"M8 15a6 6 0 0 0 12 0v-3\" /><circle cx=\"20\" cy=\"10\" r=\"2\" /></svg>", "chevrons-down": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m7 6 5 5 5-5\"/><path d=\"m7 13 5 5 5-5\"/></svg>", "circle-dot": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><circle cx=\"12\" cy=\"12\" r=\"10\" /><circle cx=\"12\" cy=\"12\" r=\"1\" /></svg>", "abdomen": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8 3c.5 2.5 1.5 4 4 4s3.5-1.5 4-4\"/><path d=\"M6 21c0-5 2.5-8 6-8s6 3 6 8\"/><path d=\"M9.5 12.5h5\"/><rect x=\"10.5\" y=\"11.5\" width=\"3\" height=\"2.5\" rx=\".4\"/></svg>", "bike": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"18.5\" cy=\"17.5\" r=\"3.5\"/><circle cx=\"5.5\" cy=\"17.5\" r=\"3.5\"/><circle cx=\"15\" cy=\"5\" r=\"1\"/><path d=\"M12 17.5V14l-3-3 4-3 2 3h2\"/></svg>", "waves": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M2 12q2.5 2 5 0t5 0 5 0 5 0\" /><path d=\"M2 19q2.5 2 5 0t5 0 5 0 5 0\" /><path d=\"M2 5q2.5 2 5 0t5 0 5 0 5 0\" /></svg>", "check": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M20 6 9 17l-5-5\" /></svg>", "mountain": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m8 3 4 8 5-5 5 15H2L8 3z\"/></svg>", "snowflake": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"m10 20-1.25-2.5L6 18\" /><path d=\"M10 4 8.75 6.5 6 6\" /><path d=\"m14 20 1.25-2.5L18 18\" /><path d=\"m14 4 1.25 2.5L18 6\" /><path d=\"m17 21-3-6h-4\" /><path d=\"m17 3-3 6 1.5 3\" /><path d=\"M2 12h6.5L10 9\" /><path d=\"m20 10-1.5 2 1.5 2\" /><path d=\"M22 12h-6.5L14 15\" /><path d=\"m4 10 1.5 2L4 14\" /><path d=\"m7 21 3-6-1.5-3\" /><path d=\"m7 3 3 6h4\" /></svg>", "neck": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"5\" r=\"2.6\"/><path d=\"M8 9h8l-1 3H9z\"/><path d=\"M4 21c1-4 4-6.5 8-6.5s7 2.5 8 6.5\"/></svg>", "run": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"14\" cy=\"4.5\" r=\"1.6\"/><path d=\"m10.5 20 1.5-4-2.5-2 1-5 3 1.5 2.5.5\"/><path d=\"M9.5 9 6 8\"/><path d=\"m12 14 3 1 1.5 4\"/></svg>", "leaf": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z\" /><path d=\"M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12\" /></svg>", "dna": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 3c0 5 16 6 16 9\"/><path d=\"M20 3c0 5-16 6-16 9\"/><path d=\"M4 21c0-5 16-6 16-9\"/><path d=\"M20 21c0-5-16-6-16-9\"/><path d=\"M7 5.5h10\"/><path d=\"M7 18.5h10\"/><path d=\"M9 8h6\"/><path d=\"M9 16h6\"/></svg>", "male": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"10\" cy=\"14\" r=\"6\"/><path d=\"M14.2 9.8 20 4\"/><path d=\"M15 4h5v5\"/></svg>", "shin": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"4\" r=\"1.8\"/><path d=\"M12 6v6\"/><path d=\"M12 12c-.8 3-1.5 5-3 8\"/><path d=\"M9 20h5\"/></svg>", "calendar": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M8 2v4\" /><path d=\"M16 2v4\" /><rect width=\"18\" height=\"18\" x=\"3\" y=\"4\" rx=\"2\" /><path d=\"M3 10h18\" /></svg>", "sparkles": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z\" /><path d=\"M20 2v4\" /><path d=\"M22 4h-4\" /><circle cx=\"4\" cy=\"20\" r=\"2\" /></svg>", "hand": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2\" /><path d=\"M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2\" /><path d=\"M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8\" /><path d=\"M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15\" /></svg>", "dumbbell": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M17.596 12.768a2 2 0 1 0 2.829-2.829l-1.768-1.767a2 2 0 0 0 2.828-2.829l-2.828-2.828a2 2 0 0 0-2.829 2.828l-1.767-1.768a2 2 0 1 0-2.829 2.829z\" /><path d=\"m2.5 21.5 1.4-1.4\" /><path d=\"m20.1 3.9 1.4-1.4\" /><path d=\"M5.343 21.485a2 2 0 1 0 2.829-2.828l1.767 1.768a2 2 0 1 0 2.829-2.829l-6.364-6.364a2 2 0 1 0-2.829 2.829l1.768 1.767a2 2 0 0 0-2.828 2.829z\" /><path d=\"m9.6 14.4 4.8-4.8\" /></svg>", "users": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2\" /><path d=\"M16 3.128a4 4 0 0 1 0 7.744\" /><path d=\"M22 21v-2a4 4 0 0 0-3-3.87\" /><circle cx=\"9\" cy=\"7\" r=\"4\" /></svg>", "racket": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"9.5\" cy=\"9.5\" r=\"6.5\"/><path d=\"M14 14l6 6\"/><path d=\"M9.5 4v11\"/><path d=\"M4 9.5h11\"/></svg>", "wind": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M12.8 19.6A2 2 0 1 0 14 16H2\" /><path d=\"M17.5 8a2.5 2.5 0 1 1 2 4H2\" /><path d=\"M9.8 4.4A2 2 0 1 1 11 8H2\" /></svg>", "zap": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z\" /></svg>", "massage-gun": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"9\" width=\"8\" height=\"4\" rx=\"1\"/><path d=\"M11 11h4\"/><rect x=\"15\" y=\"7.5\" width=\"5\" height=\"7\" rx=\"2\"/><path d=\"M7 13v3a1.5 1.5 0 0 0 3 0v-3\"/></svg>", "user": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2\" /><circle cx=\"12\" cy=\"7\" r=\"4\" /></svg>", "repeat": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"m17 2 4 4-4 4\" /><path d=\"M3 11v-1a4 4 0 0 1 4-4h14\" /><path d=\"m7 22-4-4 4-4\" /><path d=\"M21 13v1a4 4 0 0 1-4 4H3\" /></svg>", "activity": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2\" /></svg>", "sprout": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 20h10\"/><path d=\"M12 20V9\"/><path d=\"M12 11C9.5 11 6.5 9.5 6.5 5.5c4 0 5.5 2 5.5 5.5\"/><path d=\"M12 9c0-3 2-5.5 5.5-5.5C17.5 7.5 15 9 12 9\"/></svg>", "female": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"8\" r=\"6\"/><path d=\"M12 14v8\"/><path d=\"M9 18h6\"/></svg>", "football": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"m12 8 3.2 2.3-1.2 3.7h-4l-1.2-3.7z\"/><path d=\"M12 8V3.5\"/><path d=\"m14 14 3.5 1\"/><path d=\"m10 14-3.5 1\"/><path d=\"M9 10.3 5.5 8.8\"/><path d=\"M15 10.3l3.5-1.5\"/></svg>", "brain": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 4A2.5 2.5 0 0 0 7 6.5 2.5 2.5 0 0 0 5 9a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 2 4 2.5 2.5 0 0 0 2.5 2\"/><path d=\"M14.5 4A2.5 2.5 0 0 1 17 6.5 2.5 2.5 0 0 1 19 9a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1-2 4 2.5 2.5 0 0 1-2.5 2\"/><path d=\"M12 4v16\"/></svg>", "radio": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M16.247 7.761a6 6 0 0 1 0 8.478\" /><path d=\"M19.075 4.933a10 10 0 0 1 0 14.134\" /><path d=\"M4.925 19.067a10 10 0 0 1 0-14.134\" /><path d=\"M7.753 16.239a6 6 0 0 1 0-8.478\" /><circle cx=\"12\" cy=\"12\" r=\"2\" /></svg>", "credit-card": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><rect width=\"20\" height=\"14\" x=\"2\" y=\"5\" rx=\"2\" /><line x1=\"2\" x2=\"22\" y1=\"10\" y2=\"10\" /></svg>", "droplet": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z\" /></svg>", "footprints": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z\"/><path d=\"M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z\"/><path d=\"M16 17h4\"/><path d=\"M4 13h4\"/></svg>", "thigh": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9 3c1.2 3 1.4 6 .6 9\"/><circle cx=\"10\" cy=\"13\" r=\"2.4\"/><path d=\"M9.4 15.2c-.6 2.4-1.8 4.2-3.4 5.8\"/></svg>", "person-standing": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><circle cx=\"12\" cy=\"5\" r=\"1\" /><path d=\"m9 20 3-6 3 6\" /><path d=\"m6 8 6 2 6-2\" /><path d=\"M12 10v4\" /></svg>", "timer": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><line x1=\"10\" x2=\"14\" y1=\"2\" y2=\"2\" /><line x1=\"12\" x2=\"15\" y1=\"14\" y2=\"11\" /><circle cx=\"12\" cy=\"14\" r=\"8\" /></svg>", "layers": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z\" /><path d=\"M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12\" /><path d=\"M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17\" /></svg>", "refresh-cw": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8\" /><path d=\"M21 3v5h-5\" /><path d=\"M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16\" /><path d=\"M8 16H3v5\" /></svg>", "scan-line": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M3 7V5a2 2 0 0 1 2-2h2\" /><path d=\"M17 3h2a2 2 0 0 1 2 2v2\" /><path d=\"M21 17v2a2 2 0 0 1-2 2h-2\" /><path d=\"M7 21H5a2 2 0 0 1-2-2v-2\" /><path d=\"M7 12h10\" /></svg>", "chevrons-up": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m17 11-5-5-5 5\"/><path d=\"m17 18-5-5-5 5\"/></svg>", "bone": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5z\"/></svg>", "droplets": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z\" /><path d=\"M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97\" /></svg>", "columns-2": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><rect width=\"18\" height=\"18\" x=\"3\" y=\"3\" rx=\"2\" /><path d=\"M12 3v18\" /></svg>", "boxing": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9 5a4 4 0 0 0-4 4v2a3 3 0 0 0-2 3v1a3 3 0 0 0 3 3h6a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4z\"/><path d=\"M15 9h2a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-2\"/><path d=\"M5 12h3\"/></svg>", "grid-2x2": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" ><path d=\"M12 3v18\" /><path d=\"M3 12h18\" /><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" /></svg>", "gift": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"8\" width=\"18\" height=\"4\" rx=\"1\"/><path d=\"M12 8v13\"/><path d=\"M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7\"/><path d=\"M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5\"/></svg>"};
/* Kérdőjel ikon a „Nem tudom" válaszokhoz (ajándék-ág). */
ICONS['help']='<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>';
function icoSVG(k){return ICONS[k]||'';}
const CTA_ARROW='<span class="ai"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M3 9H13V4l9 8-9 8v-5H3z"/></svg></span>';
const FILTER_BASE='/collections/all';

// 0. VÁSÁRLÁS TÍPUSA (magamnak / ajándék) — külön kérdés, ez dönti el a születésnap-kérdést.
const Q_FORWHOM = { mezo:'kinek', q:'Magadnak keresed vagy ajándékba?', sub:'Csak hogy személyre tudjuk szabni az ajánlatot.',
  a:[
    {t:'Magamnak', ico:'user', tag:'Magamnak', self:true},
    {t:'Ajándékba', ico:'gift', tag:'Ajándékba', gift:true}
  ]};

/* AJÁNDÉK-ÁG SZÖVEGEI (Lexi kérése, 2026-09-14): ha a kitöltő ajándékba keres, a
   további kérdések a megajándékozottról szólnak, ezért harmadik személyben kérdeznek.
   A kérdésen: qA / subA = ajándék-ági cím és alcím. A válaszon: tA = ajándék-ági
   felirat, csakAjandek:true = a válasz csak ajándék-ágon látszik (a „Nem tudom").
   CSAK a látható szöveg változik: a tag, a facet és a mező ugyanaz, tehát a címkék,
   a metamezők, a szűrő és a 7 kérdés sem változik.
   ⚠ A csakAjandek válasz mindig a lista VÉGÉRE kerüljön: a válaszokat a teljes
   listabeli indexük azonosítja, a rejtett válasz nem csúsztathatja el a többit. */
// 1. NEM (target facet: Férfiaknak / Nőknek) — single. Magamnak = saját nem; ajándék = kinek.
const Q_GENDER_SELF = { mezo:'nem', q:'Válaszd ki a nemed', sub:'Kinek lesz az eszköz?',
  a:[
    {t:'Férfi', ico:'male', tag:'Férfi', target:'Férfiaknak'},
    {t:'Nő', ico:'female', tag:'Nő', target:'Nőknek'}
  ]};
const Q_GENDER_GIFT = { mezo:'nem', q:'Kinek keresed?', sub:'Így a neki való eszközöket mutatjuk.',
  a:[
    {t:'Férfinak', ico:'male', tag:'Férfi', target:'Férfiaknak'},
    {t:'Nőnek', ico:'female', tag:'Nő', target:'Nőknek'}
  ]};


// 1/b. SZÜLETÉSNAP — okos, progresszív mezők. Magamnak = teljes dátum (év→hó→nap), ajándék = hó→nap.
const Q_BIRTH_SELF = { birth:true, birthType:'self', q:'Mikor születtél?', sub:'Add meg a születési dátumot.' };
/* Ajándék-ágon nem a dátum a kérdés (az úgyis a megajándékozotté, és a Flow-ba
   „-" ment fel), hanem az ALKALOM: az mond valamit az ajándékról. Lexi kérése,
   2026-09-09. A válasz a reszlet mezőbe kerül „Alkalom: X" alakban. */
const Q_ALKALOM = { mezo:'reszlet', q:'Milyen alkalomra keresed?', sub:'Ez segít a megfelelő ajándékban.',
  a:[
    {t:'Születésnap', ico:'gift', tag:'Alkalom: Születésnap'},
    {t:'Névnap', ico:'sparkles', tag:'Alkalom: Névnap'},
    {t:'Évforduló', ico:'calendar', tag:'Alkalom: Évforduló'},
    {t:'Karácsony', ico:'snowflake', tag:'Alkalom: Karácsony'},
    {t:'Ballagás, vizsga, új munka', ico:'rocket', tag:'Alkalom: Ballagás vagy új munka'},
    {t:'Csak úgy, meglepetésnek', ico:'sun', tag:'Alkalom: Meglepetés'}
  ]};
const MONTHS=['január','február','március','április','május','június','július','augusztus','szeptember','október','november','december'];
// PROFI ág — TECHNOLÓGIA (multi). Csaba sorrendje. A technologia facet-értékre képződik le.
// (lökéshullám/ultrahang/kinezió/flossing → "Egyéb professzionális"; krém → nincs technologia facet, csak címke.)
const Q_TECH = { mezo:'reszlet', multi:true, q:'Milyen technológiát keresel?', sub:'Legfeljebb kettőt jelölhetsz be.',
  a:[
    {t:'Masszázspisztoly', ico:'massage-gun', tag:'Masszázspisztoly', technologia:'Masszázspisztoly'},
    {t:'Lökéshullám terápia', ico:'audio-waveform', tag:'Lökéshullám terápia', technologia:'Egyéb professzionális'},
    {t:'Ultrahang terápia', ico:'radio', tag:'Ultrahang terápia', technologia:'Egyéb professzionális'},
    {t:'Nyirokmasszázs terápia', ico:'droplets', tag:'Nyirokmasszázs terápia', technologia:'Kompresszió / nyirok'},
    {t:'Vörösfény terápia', ico:'sun', tag:'Vörösfény terápia', technologia:'Vörösfény (RLT)'},
    {t:'Hidegterápia', ico:'snowflake', tag:'Hidegterápia', technologia:'Hidegterápia'},
    {t:'Hőterápia', ico:'flame', tag:'Hőterápia', technologia:'Hőterápia'},
    {t:'Fascia kés / köpölyöző', ico:'circle-dot', tag:'Fascia kés / köpölyöző', technologia:'Köpöly / fascia'},
    {t:'Kineziológiai tapasz / flossing szalag', ico:'bandage', tag:'Kineziológiai tapasz / flossing szalag', technologia:'Egyéb professzionális'},
    {t:'Regenerációs krém', ico:'droplet', tag:'Regenerációs krém'}
  ]};


// 2. MI A CÉLOD? — Csaba listája. Fájdalom → testrész al-ág; Szakemberként → profi ág.
const Q_GOAL = { mezo:'cel', multi:true, q:'Mi a célod?', qA:'Mire használná leginkább?', sub:'Legfeljebb kettőt jelölhetsz be.',
  a:[
    {t:'Fájdalom-csillapítás', ico:'zap', tag:'Fájdalom-csillapítás', goal:'Fájdalom-csillapítás', painBranch:true},
    {t:'Teljesítmény-fokozás', ico:'rocket', tag:'Teljesítmény-fokozás', goal:'Teljesítmény-fokozás', perfBranch:true},
    {t:'Longevity & biohacking', ico:'dna', tag:'Longevity & biohacking', longBranch:true},
    {t:'Szépség & bőr', ico:'sparkles', tag:'Szépség & bőr', goal:'Szépség & bőr', beautyBranch:true},
    {t:'Szakemberként, terapeutaként használnám', tA:'Szakember (terapeuta, masszőr, edző)', ico:'stethoscope', tag:'Szakember', branch:'pro'}
  ]};

// 3. TESTRÉSZ (testresz facet) — multi, csak a Fájdalom-csillapítás ágon.
const Q_TESTRESZ = { mezo:'reszlet', multi:true, q:'Hol jelentkezik a fájdalom?', qA:'Hol jelentkezik nála a fájdalom?', sub:'Legfeljebb két testtájat jelölhetsz be.',
  a:[
    {t:'Fej / arc', ico:'brain', tag:'Fej / arc', testresz:'Fej / arc'},
    {t:'Nyak / váll', ico:'neck', tag:'Nyak / váll', testresz:'Nyak / váll'},
    {t:'Hát / gerinc', ico:'bone', tag:'Hát / gerinc', testresz:'Hát / gerinc'},
    {t:'Kar / csukló', ico:'hand', tag:'Kar / csukló', testresz:'Kar / csukló'},
    {t:'Has / csípő', ico:'abdomen', tag:'Has / csípő', testresz:'Has / csípő'},
    {t:'Comb / térd', ico:'thigh', tag:'Comb / térd', testresz:'Comb / térd'},
    {t:'Lábszár', ico:'shin', tag:'Lábszár', testresz:'Lábszár'},
    {t:'Lábfej / boka / talp', ico:'footprints', tag:'Lábfej / boka / talp', testresz:'Lábfej / boka / talp'}
  ]};

// FÁJDALOM +1 — mióta (szegmentálás, szakértő-érzet).
const Q_PAIN_SINCE = { mezo:'reszlet', q:'Mióta áll fenn a fájdalom?', qA:'Mióta zavarja a fájdalom?', sub:'Ez segít a megfelelő eszközben.',
  a:[
    {t:'Akut, pár napja', ico:'zap', tag:'Akut'},
    {t:'Krónikus, hetek vagy hónapok óta', ico:'timer', tag:'Krónikus'},
    {t:'Visszatérő, terheléskor jön elő', ico:'repeat', tag:'Visszatérő'},
    {t:'Nem tudom pontosan', ico:'help', tag:'Mióta: nem tudja', csakAjandek:true}
  ]};

// TELJESÍTMÉNY +2 — mikor + milyen sport.
const Q_PERF_WHEN = { mezo:'reszlet', q:'Mikor használnád?', qA:'Mikor használná?', sub:'Az edzéshez igazítjuk az ajánlást.', subA:'Az edzéséhez igazítjuk az ajánlást.',
  a:[
    {t:'Edzés előtt (bemelegítés, aktiválás)', ico:'chevrons-up', tag:'Edzés előtt'},
    {t:'Edzés után (regeneráció)', ico:'chevrons-down', tag:'Edzés után'},
    {t:'Mindkettő', ico:'refresh-cw', tag:'Edzés előtt és után'}
  ]};
const Q_PERF_SPORT = { mezo:'reszlet', multi:true, q:'Milyen sportot űzöl?', qA:'Milyen sportot űz?', sub:'Legfeljebb kettőt jelölhetsz be.',
  a:[
    {t:'Edzőterem / erősport / állóképesség', ico:'dumbbell', tag:'Edzőterem / erősport / állóképesség'},
    {t:'Futás', ico:'run', tag:'Futás'},
    {t:'Kerékpározás', ico:'bike', tag:'Kerékpározás'},
    {t:'Úszás', ico:'waves', tag:'Úszás'},
    {t:'Futball (foci)', ico:'football', tag:'Futball'},
    {t:'Kézilabda / kosárlabda / röplabda', ico:'users', tag:'Kézilabda / kosárlabda / röplabda'},
    {t:'Tenisz / asztalitenisz / padel / squash', ico:'racket', tag:'Tenisz / asztalitenisz / padel / squash'},
    {t:'Küzdősport (box, MMA, judo)', ico:'boxing', tag:'Küzdősport'},
    {t:'Extrém sport (sí, mászás, motor)', ico:'mountain', tag:'Extrém sport'},
    {t:'Vegyes / egyéb', ico:'activity', tag:'Vegyes / egyéb sport'}
  ]};

// LONGEVITY +2 — fő fókusz (technológiára köt!) + szint.
const Q_LONG_FOCUS = { mezo:'reszlet', multi:true, q:'Mi a fő fókuszod?', qA:'Mi érdekli leginkább?', sub:'Legfeljebb kettőt jelölhetsz be.',
  a:[
    {t:'Sejtregeneráció, energia, anti-aging', ico:'sun', tag:'Sejtregeneráció', technologia:'Vörösfény (RLT)'},
    {t:'Jeges merülés', ico:'snowflake', tag:'Jeges merülés', technologia:'Hidegterápia'},
    {t:'Gyulladáscsökkentés', ico:'bandage', tag:'Gyulladáscsökkentés', technologia:['Vörösfény (RLT)','Hidegterápia']},
    {t:'Keringés, nyirok, méregtelenítés', ico:'droplets', tag:'Keringés és nyirok', technologia:'Kompresszió / nyirok'},
    {t:'Légzés, jobb alvás', ico:'wind', tag:'Jobb alvás', goal:'Jobb alvás'},
    {t:'Stresszkezelés', ico:'leaf', tag:'Stresszkezelés', goal:'Stresszkezelés'}
  ]};
const Q_LONG_LEVEL = { mezo:'reszlet', q:'Mennyire vagy gyakorlott?', qA:'Használt már ilyen eszközt?', sub:'Hogy a megfelelő szintet ajánljuk.',
  a:[
    {t:'Kezdő, most ismerkedem', tA:'Még nem, ez lesz az első', ico:'sprout', tag:'Kezdő'},
    {t:'Haladó biohacker', tA:'Igen, rendszeresen', ico:'rocket', tag:'Haladó biohacker'},
    {t:'Nem tudom', ico:'help', tag:'Gyakorlottság: nem tudja', csakAjandek:true}
  ]};

// SZÉPSÉG & BŐR +2 — fő bőrcél + terület (szegmentálás, szakértő-érzet).
const Q_SKIN = { mezo:'reszlet', multi:true, q:'Mi a fő bőrcélod?', qA:'Mi a legfontosabb a bőrénél?', sub:'Legfeljebb kettőt jelölhetsz be.',
  a:[
    {t:'Ráncok, öregedésgátlás', tA:'Fiatalos megjelenés', ico:'timer', tag:'Öregedésgátlás'},
    {t:'Ragyogás, egységes bőrtónus', ico:'sparkles', tag:'Ragyogás'},
    {t:'Bőrfeszesség, kollagén', ico:'layers', tag:'Bőrfeszesség'},
    {t:'Cellulit, narancsbőr', tA:'Simább, formásabb bőr', ico:'grid-2x2', tag:'Cellulit'},
    {t:'Pattanás, problémás bőr', tA:'Tisztább bőr', ico:'scan-line', tag:'Problémás bőr'}
  ]};
const Q_AREA = { mezo:'reszlet', q:'Hol szeretnéd használni?', qA:'Hol használná?', sub:'Ez segít a megfelelő méretű eszközben.',
  a:[
    {t:'Arcon', ico:'user', tag:'Arcon'},
    {t:'Testen', ico:'person-standing', tag:'Testen'},
    {t:'Arcon és testen', ico:'columns-2', tag:'Arcon és testen'}
  ]};

// PROFI ág +1 — hol használja. Enélkül a szakember-ág 6 kérdés lenne, és ott nem
// jönne ki a 7 × 500 Ft-os utalvány. Egyben szegmentál is: rendelő vagy edzőterem.
const Q_PRO_WHERE = { mezo:'reszlet', q:'Hol használnád?', qA:'Hol dolgozik?', sub:'Ez segít a megfelelő teljesítményű eszközben.',
  a:[
    {t:'Saját rendelőben vagy szalonban', ico:'stethoscope', tag:'Saját rendelő'},
    {t:'Klinikán vagy csapatnál', ico:'users', tag:'Klinika / csapat'},
    {t:'Edzőteremben vagy egyesületnél', ico:'dumbbell', tag:'Edzőterem / egyesület'},
    {t:'Kiszállással, több helyszínen', ico:'activity', tag:'Mobil szolgáltatás'}
  ]};

// 5. (minden ág) — HOL HALLOTTÁL RÓLUNK? szabad szavas, KÖTELEZŐ, példa nélkül.
const Q_SOURCE = { mezo:'forras', text:true, q:'Hol hallottál rólunk?', sub:'Írd be, honnan ismersz minket, ez sokat segít nekünk.' };

/* BLACK FRIDAY 2026 (Lexi, 2026-10-18): a feliratkozói kvízben (/pages/kviz) a „Hol hallottál
   rólunk?” helyett ez a 7. kérdés. A válaszokhoz szűrt terméklistából (mindig 8, a legrelevánsabbak) EGY
   terméket választ; ebből tudjuk, mi a legvonzóbb, a BF-csomagokat mi állítjuk össze.
   A listát a templates/collection.kviz.liquid adja JSON-ban (?view=kviz), ugyanazzal a
   szűrővel, mint az eredmény gombja. A választás a bf26:<handle> címkébe megy, ami NEM
   kf: előtagú, tehát a válasz-metamezős szkript nem szedi le, szegmensben használható. */
const Q_BF_TERMEK = { mezo:'bftermek', termek:true, q:'Ha csak egyet választhatsz, melyik terméket kéred 50% kedvezménnyel?', qA:'Ha csak egyet választhatsz, melyik terméket adnád neki 50% kedvezménnyel?', sub:'' };
/* 2026-10-25 (Lexi): a bolti popup-kvízben is a termékválasztó a 7. kérdés, a „Hol hallottál rólunk?” kikerült.
   A Q_SOURCE marad (forrasCimke és a régi válaszok miatt), csak nem kérdezzük. */
function hetedikKerdes(){ return longMod() ? Q_LS_MIKOR : Q_BF_TERMEK; }

/* A Longevity Summit kvíz záró kérdése (Lexi, 2026-09-20). A „Hol hallottál rólunk?"
   ott nem mond semmit, mert a kitöltő a rendezvényről jön; helyette azt kérdezzük,
   mennyire sürgős neki. A válasz a reszlet mezőbe megy, tehát nem kell új metamező,
   és a kérdések száma marad 7 (ez adja a 7 × 500 Ft-os keretet). */
const Q_LS_MIKOR = { mezo:'reszlet', q:'Mikor kezdenél bele?', qA:'Mikor kezdené el?',
  sub:'', subA:'',                                          // alcím nélkül (Lexi, 2026-09-20)
  a:[
    {t:'Most azonnal', ico:'zap', tag:'Kezdés: azonnal'},
    {t:'1-2 héten belül', ico:'timer', tag:'Kezdés: 1-2 hét'},
    {t:'Egy hónapon belül', ico:'calendar', tag:'Kezdés: egy hónap'},
    {t:'Még csak nézelődöm', tA:'Még csak nézelődik', ico:'help', tag:'Kezdés: nézelődik'}
  ]};

let flow=[], step=0, tags=[], multiSel=[], facets={}, sourceVal='', kvizElozmeny=[];
let leadIn=[], purchase='sajat', birth={y:'',m:'',d:''}, birthMode='self';
/* A válaszok mezőnként, hogy a Flow a megfelelő vevő-metamezőbe tudja tenni őket. */
function ujValaszok(){ return {kinek:'', nem:'', cel:'', reszlet:[], forras:'', bftermek:'', bftermekNev:''}; }
let valaszok=ujValaszok();
/* Ajándék-ág: a kérdések a megajándékozottról szólnak (lásd AJÁNDÉK-ÁG SZÖVEGEI fent). */
function ajandekAg(){ return purchase==='ajandek'; }
function kerdesCim(Q){ return (ajandekAg() && Q.qA) ? Q.qA : Q.q; }
function kerdesAlcim(Q){ return (ajandekAg() && Q.subA) ? Q.subA : Q.sub; }
function valaszFelirat(a){ return (ajandekAg() && a.tA) ? a.tA : a.t; }
function valaszLatszik(a){ return !a.csakAjandek || ajandekAg(); }
/* A záró képernyők szövegei: ahol a sablonban data-ajandek-szoveg áll, ajándék-ágon
   az jelenik meg, egyébként az eredeti. Az eredetit az első híváskor eltesszük,
   így oda-vissza váltható (Vissza gomb, új kitöltés). */
function ajandekFeliratok(){
  var elemek=document.querySelectorAll('[data-ajandek-szoveg]');
  for(var i=0;i<elemek.length;i++){
    var el=elemek[i];
    if(!el.hasAttribute('data-sajat-szoveg')) el.setAttribute('data-sajat-szoveg', el.textContent);
    el.textContent = ajandekAg() ? el.getAttribute('data-ajandek-szoveg') : el.getAttribute('data-sajat-szoveg');
  }
}
function rogzit(mezo, ertek){
  if(!mezo || !ertek) return;
  if(mezo==='reszlet'){ if(valaszok.reszlet.indexOf(ertek)===-1) valaszok.reszlet.push(ertek); }
  else valaszok[mezo]=ertek;
}

// állapot-pillanatkép a visszalépéshez
function snapshot(){ return {flow:flow.slice(), step:step, tags:tags.slice(), facets:JSON.parse(JSON.stringify(facets)), sourceVal:sourceVal, leadIn:leadIn.slice(), purchase:purchase, birth:{y:birth.y,m:birth.m,d:birth.d}, birthMode:birthMode, valaszok:JSON.parse(JSON.stringify(valaszok))}; }
function pushHistory(){ kvizElozmeny.push(snapshot()); }
function backBtnHtml(){ return kvizElozmeny.length ? '<button class="back" onclick="goBack()"><span class="barr">&larr;</span> Vissza</button>' : '<span></span>'; }
function goBack(){
  if(!kvizElozmeny.length) return;
  const s=kvizElozmeny.pop();
  flow=s.flow; step=s.step; tags=s.tags; facets=s.facets; sourceVal=s.sourceVal; multiSel=[];
  leadIn=s.leadIn; purchase=s.purchase; birth=s.birth; birthMode=s.birthMode; valaszok=s.valaszok||ujValaszok();
  document.getElementById('gate').style.display='none';
  document.getElementById('result').style.display='none';
  document.getElementById('progwrap').style.display='block';
  document.getElementById('qbox').style.display='block';
  renderQuestion();
}

function popupMod(){ return !!document.getElementById('kvizPopup'); }
/* A popup mobil fejlecképe csak a nyitóképernyon és az eredménynél látszik: a
   fázist a kvíz dobozának osztálya jelzi, a CSS ebbol tudja, mekkora a kép.
   A landingen nincs [data-kviz-popup], ott ez nem csinál semmit. */
/* ============================================================
   ANALITIKA (2026-10-04) — a kvíz eseményei a MOVTECH ajánlatok app közös
   küldőjén (window.mvtAnalitika) mennek a GA4-be. Ha az app nincs betöltve,
   csendben kimarad. Személyes adat (e-mail, születésnap, válasz-szöveg) NEM megy.
     megjelenes    — a popup felugrott
     kattintas     — cel: kezdes / feliratkozas / eredmeny
     kviz_lepes    — elért egy kérdést (lepes 1..7; visszalépéskor nem ismétlődik)
     kviz_email    — eljutott az e-mail lépésig
     kviz_kitoltve — beküldte, megkapta a kupont
     bezaras       — bezárta (fazis + a legmesszebb elért lépés)
   ============================================================ */
var kvizMaxLepes=0, kvizAktFazis='intro';
function kvizMeres(nev, extra){
  try{
    if(!window.mvtAnalitika) return;
    var adat={
      popup_tipus:'kviz',
      popup_nev: longMod() ? 'kviz-longevity' : (felirMod() ? 'kviz-feliratkozo' : 'kviz'),
      hely: document.querySelector('[data-kviz-popup]') ? 'popup' : 'landing'
    };
    for(var k in (extra||{})) adat[k]=extra[k];
    window.mvtAnalitika.esemeny(nev, adat);
  }catch(e){}
}
document.addEventListener('click', function(e){
  var t=e.target && e.target.closest && e.target.closest('#resBtn');
  if(t) kvizMeres('kattintas', {cel:'eredmeny'});
}, true);
function kvizFazis(nev){
  kvizAktFazis=nev;
  var d=document.querySelector('[data-kviz-popup]');
  if(!d) return;
  d.classList.remove('fazis-intro','fazis-kerdes','fazis-email','fazis-gate','fazis-eredmeny');
  if(nev==='email') d.classList.add('fazis-kerdes');   // az e-mail lépés a kérdések világos kinézetét viszi
  d.classList.add('fazis-'+nev);
}
function overlayNyit(){ var o=document.getElementById('overlay'); if(o) o.classList.add('show'); }
function overlayZar(){ var o=document.getElementById('overlay'); if(o) o.classList.remove('show'); }
/* A tűzijáték, a konfetti és a hangok külön fájlban vannak. A landingen a saját
   layout tölti be őket, a popup viszont MINDEN oldalon ott van, ezért csak akkor
   kérjük le a két fájlt, amikor a kvíz tényleg elindul vagy az eredmény jön.
   Az URL-jük a kvíz script-tagjén van (data-kviz-fx / data-kviz-sfx). */
var fxKerve=false, fxVarok=[];
function fxKesz(){ var v=fxVarok.slice(); fxVarok=[]; for(var i=0;i<v.length;i++){ try{ v[i](); }catch(e){} } }
function fxBetolt(kesz){
  if(window.MovtechFX && window.MovtechSFX){ if(kesz) kesz(); return; }
  if(kesz) fxVarok.push(kesz);
  if(fxKerve) return;
  fxKerve=true;
  var sc=document.querySelector('script[data-kviz-fx]');
  if(!sc){ fxKesz(); return; }
  var maradt=2;
  ['data-kviz-fx','data-kviz-sfx'].forEach(function(attr){
    var url=sc.getAttribute(attr);
    if(!url){ if(--maradt<=0) fxKesz(); return; }
    var uj=document.createElement('script');
    uj.src=url;
    uj.onload=uj.onerror=function(){ if(--maradt<=0) fxKesz(); };
    document.head.appendChild(uj);
  });
}

function startQuiz(){
  flow=[Q_FORWHOM,Q_GENDER_SELF,Q_GOAL]; step=0; tags=[]; multiSel=[]; sourceVal=''; kvizElozmeny=[];
  leadIn=[Q_FORWHOM,Q_GENDER_SELF]; purchase='sajat'; birth={y:'',m:'',d:''}; birthMode='self'; valaszok=ujValaszok();
  facets={target:[],goal:[],testresz:[],technologia:[]};
  fxBetolt();                                                // effektek előre
  facetGidBetolt();                                          // szűrő-azonosítók a háttérben
  overlayNyit();
  var intro=document.getElementById('kvizIntro');            // popup: nyitóblokk
  if(intro) intro.style.display='none';
  document.getElementById('progwrap').style.display='block';
  document.getElementById('gate').style.display='none';
  document.getElementById('result').style.display='none';
  document.getElementById('progwrap').style.display='block';
  document.getElementById('qbox').style.display='block';
  egyenlegNullaz();
  kvizMaxLepes=0;
  kvizMeres('kattintas', {cel:'kezdes'});
  renderQuestion();
}
function closeQuiz(){ overlayZar(); }
function totalSteps(){ return flow.length>4 ? flow.length : 7; } // vásárlás-típus, nem, születésnap, cél, +2 al-kérdés, forrás — minden ágon 7
const ORDINALS=['Első','Második','Harmadik','Negyedik','Ötödik','Hatodik','Hetedik'];

/* ============================================================
   EGYENLEG-SZÁMLÁLÓ — minden megválaszolt kérdés 500 Ft-ot ér, a hetedik
   után teljes a 3 500 Ft-os ajándékutalvány. A doboz a haladásjelző alatt
   ül, és minden válasz után felszámol az új összegre.
   A kvíz minden ága 7 kérdés, tehát az érték ágtól függetlenül ugyanaz.
   ============================================================ */
const VALASZ_ERTEK = 500;                       // Ft / megválaszolt kérdés
const UTALVANY_MAX = 3500;                      // 7 × 500 Ft, ennyi a kupon értéke
var egyenlegKijelzett = 0;                      // az utoljára KIÍRT összeg (az animációhoz)
var egyenlegOra = null;

function ftAlak(n){ return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Ft'; }

/* Hány kérdésre válaszolt eddig. A finishQuiz teljes összeget kér (kesz=true),
   hogy a záró képernyőn biztosan a kupon értéke álljon. */
function egyenlegOsszeg(kesz){
  if(kesz) return UTALVANY_MAX;
  return Math.min(step * VALASZ_ERTEK, UTALVANY_MAX);
}

function egyenlegFrissit(kesz, csendben){
  var doboz=document.getElementById('balance');
  if(!doboz) return;                                    // régi sablon: nincs számláló
  doboz.style.display='flex';
  if(csendben) egyenlegKijelzett=egyenlegOsszeg(kesz);  // beküldés utáni visszatérés: ne számoljon fel újra
  var cel=egyenlegOsszeg(kesz);
  var hatra=Math.max(0, Math.round((UTALVANY_MAX-cel)/VALASZ_ERTEK));
  var sug=document.getElementById('balHint');
  if(sug){
    if(hatra===0)      sug.textContent='Megvan a teljes összeg, a tiéd.';
    else if(hatra===1) sug.textContent='Még 1 válasz, és tiéd a teljes ' + ftAlak(UTALVANY_MAX) + '.';
    else               sug.textContent='Még ' + hatra + ' válasz a teljes ' + ftAlak(UTALVANY_MAX) + '-ig.';
  }
  doboz.classList.toggle('teljes', cel>=UTALVANY_MAX);
  if(cel>egyenlegKijelzett) egyenlegBuborek(doboz, cel-egyenlegKijelzett);
  egyenlegSzamol(egyenlegKijelzett, cel);
  egyenlegKijelzett=cel;
}

/* Felszámolás a régi értékről az újra. 10 Ft-ra kerekít futás közben, a végén
   pontosan az új összeget írja ki. */
function egyenlegSzamol(tol, ig){
  var el=document.getElementById('balSum');
  if(!el) return;
  if(egyenlegOra){ clearInterval(egyenlegOra); egyenlegOra=null; }
  var nincsMozgas=false;
  try{ nincsMozgas=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }catch(e){}
  if(tol===ig || nincsMozgas){ el.textContent=ftAlak(ig); return; }
  var start=Date.now(), ido=520;
  egyenlegOra=setInterval(function(){
    var t=Math.min(1,(Date.now()-start)/ido);
    var e=1-Math.pow(1-t,3);                            // lassuló vég
    if(t>=1){ clearInterval(egyenlegOra); egyenlegOra=null; el.textContent=ftAlak(ig); return; }
    el.textContent=ftAlak(Math.round((tol+(ig-tol)*e)/10)*10);
  },16);
}

/* A „+500 Ft" felúszó buborék. Magától eltűnik, nem hagy szemetet a DOM-ban. */
function egyenlegBuborek(doboz, mennyi){
  var b=document.createElement('span');
  b.className='bal-pop';
  b.textContent='+' + ftAlak(mennyi);
  doboz.appendChild(b);
  setTimeout(function(){ if(b.parentNode) b.parentNode.removeChild(b); }, 1100);
}

/* Nulláról indul minden új kitöltésnél. */
function egyenlegNullaz(){
  egyenlegKijelzett=0;
  if(egyenlegOra){ clearInterval(egyenlegOra); egyenlegOra=null; }
  var el=document.getElementById('balSum');
  if(el) el.textContent=ftAlak(0);
}

function renderQuestion(){
  kvizFazis('kerdes');
  const Q=flow[step], N=totalSteps();
  const pct=Math.round((step+1)/N*100);
  document.getElementById('progpct').textContent=pct+'%';
  document.getElementById('progtxt').textContent=(ORDINALS[step]||(step+1)+'.')+' kérdés · '+(step+1)+' / '+N;
  document.getElementById('progfill').style.width=pct+'%';
  egyenlegFrissit(false);                                           // eddig összegyűjtött utalvány
  if(step+1>kvizMaxLepes){                                          // analitika: csak előre haladáskor
    kvizMaxLepes=step+1;
    kvizMeres('kviz_lepes', {lepes:step+1, lepes_ossz:N, kerdes:Q.mezo||('kerdes_'+(step+1))});
  }
  let h=`<div class="qtitle">${kerdesCim(Q)}</div><div class="qsub">${kerdesAlcim(Q)}</div>`;
  if(Q.termek){ termekKerdes(h); return; }                        // BF 2026: termékválasztó (feliratkozói mód)
  if(Q.text){                                                       // szabad szavas, kötelező kérdés
    h+=`<input type="text" class="qinput" id="qtext" placeholder="" autocomplete="off" oninput="document.getElementById('textBtn').disabled=!this.value.trim()" onkeydown="if(event.key==='Enter')nextText()">`;
    h+=`<div class="quiznav">${backBtnHtml()}<button class="btn" id="textBtn" onclick="nextText()" disabled>Tovább ${CTA_ARROW}</button></div>`;
    document.getElementById('qbox').innerHTML=h;
    setTimeout(()=>{const t=document.getElementById('qtext'); if(t)t.focus();},40);
    return;
  }
  if(Q.birth){                                                      // progresszív születésnap-mezők
    birthMode = Q.birthType || 'self';
    // nincs alapértelmezett év: a mező üresen indul, a hónap csak választás után jön
    const showYear = true;                       // mindkét ág évvel kezd: év → hónap → nap
    const yearLabel = 'Év';
    let b='';
    if(showYear){
      b+=`<div class="birthrow"><label class="blab">${yearLabel}</label>`+
         `<select class="qinput qsel" id="byear" onchange="onBirthYear()">${yearOptions(birth.y)}</select></div>`;
    }
    const monthHidden = showYear ? (birth.y? '':'display:none') : '';   // ajándéknál a hónap rögtön látszik
    b+=`<div class="birthrow" id="bmonthrow" style="${monthHidden}"><label class="blab">Hónap</label>`+
       `<select class="qinput qsel" id="bmonth" onchange="onBirthMonth()">${monthOptions(birth.m)}</select></div>`;
    const dayHidden = birth.m? '':'display:none';
    b+=`<div class="birthrow" id="bdayrow" style="${dayHidden}"><label class="blab">Nap</label>`+
       `<select class="qinput qsel" id="bday" onchange="onBirthDay()">${dayOptions(birth.d)}</select></div>`;
    h+=`<div class="birthwrap">${b}</div>`;
    h+=`<div class="quiznav">${backBtnHtml()}<button class="btn" id="birthBtn" onclick="nextBirth()" ${birthReady()?'':'disabled'}>Tovább ${CTA_ARROW}</button></div>`;
    document.getElementById('qbox').innerHTML=h;
    if(showYear) setTimeout(()=>{const y=document.getElementById('byear'); if(y&&!birth.y)y.focus();},40);
    else setTimeout(()=>{const m=document.getElementById('bmonth'); if(m)m.focus();},40);
    return;
  }
  h+=`<div class="answers">`;
  if(Q.multi){
    multiSel=[];
    Q.a.forEach((a,i)=>{ if(!valaszLatszik(a)) return; h+=`<button class="ans" id="opt${i}" onclick="toggleMulti(${i})"><span class="ico">${icoSVG(a.ico)}</span> ${valaszFelirat(a)}<span class="chk"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ><path d="M20 6 9 17l-5-5" /></svg></span></button>`; });
    h+=`</div><div class="quiznav">${backBtnHtml()}<button class="btn" id="multiBtn" onclick="nextMulti()" disabled>Tovább ${CTA_ARROW}</button></div>`;
  } else {
    Q.a.forEach((a,i)=>{ if(!valaszLatszik(a)) return; h+=`<button class="ans" onclick="pick(${i})"><span class="ico">${icoSVG(a.ico)}</span> ${valaszFelirat(a)}</button>`; });
    h+=`</div>`;
    if(kvizElozmeny.length) h+=`<div class="quiznav">${backBtnHtml()}</div>`;
  }
  document.getElementById('qbox').innerHTML=h;
}
/* A cél-kérdés ága: melyik két kérdés jön a bejelölt cél után. Több bejelölt célnál
   az ELSŐNEK bejelölt (elsődleges) cél adja az ágat, így a kvíz 7 kérdés marad. */
function celAg(a){
  if(a.branch==='pro')  return [Q_TECH,Q_PRO_WHERE];
  if(a.painBranch)      return [Q_TESTRESZ,Q_PAIN_SINCE];
  if(a.perfBranch)      return [Q_PERF_WHEN,Q_PERF_SPORT];
  if(a.longBranch)      return [Q_LONG_FOCUS,Q_LONG_LEVEL];
  if(a.beautyBranch)    return [Q_SKIN,Q_AREA];
  return [];
}
// a válasz facet-értékeit beemeli a facets gyűjtőbe (érték lehet string vagy tömb)
/* Melyik szuro-mezot allitja ez a valasz. Egy valasz legfeljebb egyet allit,
   ezert az elso talalat eleg. Facet nelkuli valasznal null (pl. "Regeneracios krem"). */
function facetMezo(a){ for(const f of ['target','goal','testresz','technologia']) if(a[f]) return f; return null; }
function applyFacet(a){ for(const f of ['target','goal','testresz','technologia']){ const v=a[f]; if(!v) continue; (Array.isArray(v)?v:[v]).forEach(x=>{ if(!facets[f].includes(x)) facets[f].push(x); }); } }
function pick(i){
  pushHistory();
  const Qc=flow[step];
  const a=Qc.a[i];
  tags.push(a.tag);
  rogzit(Qc.mezo, a.tag);
  if(Qc===Q_FORWHOM){                                         // vásárlás típusa: eldönti a nem- és születésnap-kérdést
    purchase = a.self ? 'sajat' : 'ajandek';
    const genderQ = a.self ? Q_GENDER_SELF : Q_GENDER_GIFT;
    const birthQ  = a.self ? Q_BIRTH_SELF  : Q_ALKALOM;   // ajándéknál alkalom, nem dátum
    birthMode = a.self ? 'self' : 'gift';
    birth={y:'',m:'',d:''};
    leadIn=[Q_FORWHOM,genderQ,birthQ];
    flow=leadIn.concat([Q_GOAL]);
  } else if(Qc===Q_GENDER_SELF || Qc===Q_GENDER_GIFT){
    applyFacet(a);
  } else if(Qc===Q_GOAL){                                     // a cél dönti el a további ágat
    if(a.branch==='pro') facets.target=['Szakembereknek']; else applyFacet(a);
    flow=leadIn.concat([Q_GOAL], celAg(a), [hetedikKerdes()]);
  } else {
    applyFacet(a);
  }
  step++;
  if(step<flow.length) renderQuestion(); else finishQuiz();
}

// ---- születésnap okos-mezők ----
function pad(x){ return String(x).padStart(2,'0'); }
/* ⚠ Az évnek NINCS alapértéke: minden kérdésre valódi választ kérünk (Lexi
   kérése, 2026-09-09). Korábban 1980 volt előre kiválasztva, így az évet meg
   lehetett úszni, és mindenki 1980-as születésűként ment be az adatbázisba. */
function yearOptions(sel){ var o='<option value="">Válassz…</option>'; for(var y=1940;y<=2010;y++){ o+='<option value="'+y+'"'+(String(y)===String(sel)?' selected':'')+'>'+y+'</option>'; } return o; }   // 1940–2010
function monthOptions(sel){ var o='<option value="">Válassz…</option>'; for(var i=0;i<12;i++){ var v=i+1; o+='<option value="'+v+'"'+(String(v)===String(sel)?' selected':'')+'>'+MONTHS[i]+'</option>'; } return o; }
function daysInMonth(){ var m=parseInt(birth.m,10); if(!m) return 31; if(birth.y){ return new Date(parseInt(birth.y,10), m, 0).getDate(); } return [31,29,31,30,31,30,31,31,30,31,30,31][m-1]; }
function dayOptions(sel){ var n=daysInMonth(); var o='<option value="">Válassz…</option>'; for(var d=1;d<=n;d++){ o+='<option value="'+d+'"'+(String(d)===String(sel)?' selected':'')+'>'+d+'</option>'; } return o; }
function birthReady(){ return !!birth.y && !!birth.m && !!birth.d; }   // teljes dátum kell: év, hónap, nap
function onBirthYear(){
  var el=document.getElementById('byear'); var v=el.value;
  var valid=/^\d{4}$/.test(v);
  birth.y = valid? v:'';
  var mr=document.getElementById('bmonthrow'); if(mr) mr.style.display = valid?'flex':'none';
  if(!valid){ birth.m=''; birth.d=''; var dr=document.getElementById('bdayrow'); if(dr)dr.style.display='none'; var ms=document.getElementById('bmonth'); if(ms)ms.value=''; }
  else { if(parseInt(birth.d,10) > daysInMonth()) birth.d='';   // febr. 29. nem szökőévben
    var ds=document.getElementById('bday'); if(ds) ds.innerHTML=dayOptions(birth.d); }
  var b=document.getElementById('birthBtn'); if(b)b.disabled=!birthReady();
}
function onBirthMonth(){
  var el=document.getElementById('bmonth'); birth.m=el.value;
  var dr=document.getElementById('bdayrow');
  if(birth.m){ if(parseInt(birth.d,10) > daysInMonth()) birth.d='';   // rövidebb hónapnál a nap érvénytelenné válhat
    var ds=document.getElementById('bday'); if(ds) ds.innerHTML=dayOptions(birth.d); if(dr) dr.style.display='flex'; }
  else { birth.d=''; if(dr) dr.style.display='none'; }
  var b=document.getElementById('birthBtn'); if(b)b.disabled=!birthReady();
}
function onBirthDay(){ birth.d=document.getElementById('bday').value;
  var b=document.getElementById('birthBtn'); if(b)b.disabled=!birthReady();
}
function nextBirth(){
  if(!birthReady()) return;
  pushHistory();
  step++;
  if(step<flow.length) renderQuestion(); else finishQuiz();
}
function birthStr(){
  if(!birth.y) return ''; var s=birth.y; if(birth.m){ s+='-'+pad(birth.m); if(birth.d) s+='-'+pad(birth.d); } return s;
}
/* Legfeljebb ennyi válasz jelölhető be egy többválasztós kérdésnél. Lexi kérése
   2026-09-08: a célnál és az utána következő kérdéseknél is kettő a felső határ,
   így az ajánlás fókuszált marad. A landingen ugyanez a szabály él. */
const MULTI_MAX = 2;
function toggleMulti(i){
  const idx=multiSel.indexOf(i);
  if(idx>=0) multiSel.splice(idx,1);
  else {
    if(multiSel.length>=MULTI_MAX) return;      // a harmadik jelölést nem engedjük
    multiSel.push(i);
  }
  document.getElementById('opt'+i).classList.toggle('selected');
  document.getElementById('multiBtn').disabled = multiSel.length===0;
  multiTelitett();
}
/* Ha megvan a két válasz, a többi lehetőség halványan és kattinthatatlanul marad,
   hogy a korlát látszódjon. A bejelöltek kattinthatók maradnak: azokkal lehet
   visszavonni a választást. */
function multiTelitett(){
  var tele = multiSel.length>=MULTI_MAX;
  var dobozok = document.querySelectorAll('#qbox .ans');
  for(var i=0;i<dobozok.length;i++){
    dobozok[i].classList.toggle('tilt', tele && multiSel.indexOf(i)<0);
  }
}
function nextMulti(){
  pushHistory();
  const Q=flow[step];
  if(Q===Q_GOAL){
    /* Több cél is bejelölhető. Az ELSŐNEK bejelölt az elsődleges: ő adja a következő
       két kérdést és a q:cel: címkét (abból lesz a kviz_cel metamező). A többi cél a
       szűrőbe és a részletek közé kerül, hogy az ajánlás mindet figyelembe vegye. */
    const elsodleges = Q.a[multiSel[0]];
    /* ⚠ A masodlagos cel CSAK akkor kerul a szurobe, ha ugyanabba a szuro-mezobe esik,
       mint az elsodleges. Kulonbozo mezok ES-kapcsolatba kerulnek a Shopify szuroben,
       es konnyen kiuresitik a listat: "Szakember + Szepseg & bor" = target-szakember
       ES goal-beauty ES tech-profi -> 0 talalat (merve 2026-09-09, elesben is).
       A cimke es a reszlet-mezo valtozatlanul minden bejelolt celt megkap, csak a
       szuro szukebb. */
    const celMezo = elsodleges.branch==='pro' ? 'target' : facetMezo(elsodleges);
    multiSel.forEach(i=>{
      const a=Q.a[i];
      tags.push(a.tag);
      if(a===elsodleges) rogzit('cel', a.tag); else rogzit('reszlet', 'Cél: '+a.tag);
      if(a.branch==='pro'){ if(a===elsodleges) facets.target=['Szakembereknek']; return; }
      if(a===elsodleges || facetMezo(a)===celMezo) applyFacet(a);
    });
    flow=leadIn.concat([Q_GOAL], celAg(elsodleges), [hetedikKerdes()]);
  } else {
    /* Ugyanaz a szabaly a tobbi ket-valaszos kerdesre. A longevity fokusz-kerdesben
       pl. a "Jeges merules" technologiat, a "Legzes, jobb alvas" celt allit: egyutt
       tech-hideg ES goal-alvas, amire nincs termek. Az elso bejelolt valasz mezoje
       dont, a masik csak cimke marad. */
    var fMezo=null;
    multiSel.forEach(i=>{ if(fMezo===null) fMezo=facetMezo(Q.a[i]); });
    multiSel.forEach(i=>{
      const a=Q.a[i];
      tags.push(a.tag); rogzit(Q.mezo, a.tag);
      if(facetMezo(a)===null || facetMezo(a)===fMezo) applyFacet(a);
    });
  }
  step++;
  if(step<flow.length) renderQuestion(); else finishQuiz();
}
/* BF 2026 termékválasztó. A lista a válaszok szűrőjével jön; ha 4-nél kevesebb termék
   maradna, előbb csak a cél-szűrővel, végül szűrő nélkül (legnépszerűbbek) kérjük le. */
var termekCache = {}, termekNevek = {};   // handle → terméknév (a metamezőbe a név megy)
function termekLista(url){
  if(termekCache[url]) return Promise.resolve(termekCache[url]);
  var u = url + (url.indexOf('?')>=0 ? '&' : '?') + 'view=kviz&sort_by=best-selling';
  return fetch(u, {credentials:'same-origin'})
    .then(function(r){ return r.ok ? r.json() : []; })
    .then(function(l){ l = Array.isArray(l) ? l : []; termekCache[url]=l; return l; })
    .then(function(l){                            // a lökéshullám-gép csak szakembernek
      var pro = facets.target.indexOf('Szakembereknek') >= 0;
      return pro ? l : l.filter(function(p){ return p.tipus !== 'Lökéshullám'; });
    })
    .catch(function(){ return []; });
}
function celUrl(){
  var parts=[];
  facets.goal.forEach(function(v){ parts.push('filter.p.m.custom.goal='+encodeURIComponent(facetKulcs('goal', v))); });
  return FILTER_BASE + (parts.length ? '?'+parts.join('&') : '');
}
function termekKerdes(h){
  h += '<div class="bftermekek" id="bfTermekek"><div class="bf-tolt">Termékek betöltése…</div></div>';
  h += '<div class="quiznav">'+backBtnHtml()+'</div>';
  document.getElementById('qbox').innerHTML = h;
  var lepes = step;
  var szurt = buildFilterUrl();
  /* Mindig 8 termék (Lexi, 2026-10-18): elöl a válaszok összes szűrőjével kapott termékek
     (legrelevánsabb), ha ez kevés, a cél-szűrős lista, végül a legnépszerűbbek egészítik ki. */
  function hozzaad(cel, l){ l.forEach(function(p){ if(cel.length < 8 && !cel.some(function(x){ return x.handle === p.handle; })) cel.push(p); }); return cel; }
  termekLista(szurt).then(function(l){
    var ki = hozzaad([], l);
    if(ki.length >= 8) return ki;
    return termekLista(celUrl()).then(function(l2){
      hozzaad(ki, l2);
      if(ki.length >= 8) return ki;
      return termekLista(FILTER_BASE).then(function(l3){ return hozzaad(ki, l3); });
    });
  }).then(function(l){
    if(step !== lepes) return;                      // közben visszalépett
    var doboz = document.getElementById('bfTermekek');
    if(!doboz) return;
    var n = Math.min(8, l.length); if(n > 1 && n % 2) n--;   // normál esetben 8; páros, ha a bolt kevesebbet adna
    l = l.slice(0, n);
    doboz.className = 'bftermekek bfo-' + (n >= 8 ? 4 : (n === 6 ? 3 : Math.max(n, 2)));
    if(!l.length){ doboz.innerHTML = '<div class="bf-tolt">Most nem sikerült betölteni a termékeket.</div><button class="btn" data-h="-" onclick="pickTermek(this.dataset.h)">Tovább '+CTA_ARROW+'</button>'; return; }
    doboz.innerHTML = l.map(function(p){
      termekNevek[String(p.handle)] = String(p.cim || '');
      return '<button type="button" class="bftermek" data-h="'+String(p.handle).replace(/[^a-z0-9-]/gi,'')+'" onclick="pickTermek(this.dataset.h)">'+
        (p.kep ? '<img src="'+p.kep+'" alt="" width="200" height="200">' : '<span class="bf-nokep"></span>')+
        '<span class="bf-nev">'+String(p.cim).replace(/</g,'&lt;')+'</span></button>';
    }).join('');
  });
}
function pickTermek(handle){
  pushHistory();
  valaszok.bftermek = (handle && handle !== '-') ? handle : '';
  valaszok.bftermekNev = valaszok.bftermek ? (termekNevek[valaszok.bftermek] || valaszok.bftermek) : '';
  if(valaszok.bftermek) tags.push('bf26:'+valaszok.bftermek);
  step++;
  if(step<flow.length) renderQuestion(); else finishQuiz();
}
function nextText(){
  const t=document.getElementById('qtext'); const v=t?t.value.trim():'';
  if(!v) return;                                                    // kötelező
  pushHistory();
  sourceVal=v; tags.push('forras-megadva'); valaszok.forras=forrasCimke(v);
  step++;
  if(step<flow.length) renderQuestion(); else finishQuiz();
}
function finishQuiz(){
  egyenlegFrissit(true);                                    // az utolsó +500, teljes az utalvány
  ajandekFeliratok();                                       // ajándék-ágon a megajándékozottról szól
  document.getElementById('kvizTags').value=buildTags();
  kvizMeres('kviz_email', {lepes_ossz:flow.length, ag:purchase});
  if(felirMod() && linkEmail){ telefonLepes(); return; }   // a hírlevél-linkből jött: az e-mail már megvan
  emailLepes();
}

/* ============================================================
   A KÉT ZÁRÓ LÉPÉS (Csaba levele, 2026-10-04)
   1. E-mail: ugyanabban a fehér, kérdés-kinézetben, mint a 7 kérdés
      (haladásjelző 100% „Majdnem kész", összeg-doboz, cím, mező, Vissza / Tovább).
      A JS rajzolja a #qbox-ba, ezért a popupban és a Longevity kvízben egyforma.
   2. Telefonszám: a fekete utalvány-képernyő (#gate), +36 előtaggal. Az űrlapot
      ez küldi be, egyszer: az e-mail a rejtett contact[email] mezőbe kerül, a szám
      `tel:+36…` címkében megy (a hírlevél-űrlap csak címkét fogad), és ha bepipálta
      az SMS-hozzájárulást, `sms-marketing` címkét is kap. Az SMS-t a Shopify Flow
      küldi ki a BIP-en át a címke alapján; a böngésző semmilyen kulcsot nem lát.
   ============================================================ */
var emailErtek='', emailOptin=false;

/* FELIRATKOZÓI KVÍZ (/pages/kviz, 2026-10-05): a meglévő feliratkozóknak megy ki hírlevélben.
   A levél gombja a link # utáni részében hozza a vevő e-mail címét (#e=<cím>), így neki
   nincs e-mail lépés: a 7 kérdés után egyből a telefonszám jön. A # utáni rész nem megy a
   szerverre, és betöltés után azonnal le is vesszük a címsorból (history.replaceState),
   hogy se a GA4-be, se egy továbbküldött linkbe ne kerüljön. Link nélkül (továbbküldték,
   kézzel nyitották) a rendes e-mail lépés jön. */
var linkEmail='';
(function(){
  try{
    var m=(window.location.hash||'').match(/[#&]e=([^&]+)/);
    if(!m) return;
    var e=decodeURIComponent(m[1]).trim();
    if(emailJo(e)){ linkEmail=e; emailErtek=e; }
    // ⚠ window.history kell: a kvíz saját `history` változója (a kérdések előzménye) eltakarja a böngészőét.
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  }catch(err){}
})();
function emailJo(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v).trim()); }
function emailLepes(hiba){
  kvizFazis('email');
  document.getElementById('gate').style.display='none';
  document.getElementById('result').style.display='none';
  document.getElementById('progwrap').style.display='block';
  document.getElementById('progfill').style.width='100%';
  document.getElementById('progpct').textContent='100%';
  document.getElementById('progtxt').textContent='Majdnem kész';
  var h='<div class="qtitle">Megvan a <span class="egyben">3 500 Ft-os</span> utalványod!</div>'+
    '<div class="qsub">Add meg az e-mail címed, amire az utalványt küldhetjük.</div>'+
    '<input type="email" class="qinput" id="emailLepesMezo" placeholder="E-mail cím" autocomplete="email" inputmode="email"'+
      ' oninput="emailEllenoriz()" onkeydown="if(event.key===\'Enter\')emailTovabb()">'+
    '<label class="checkrow"><input type="checkbox" id="optin" onchange="emailEllenoriz()">'+
      '<span>Elfogadom az <a href="/pages/adatvedelmi-tajekoztato" target="_blank" rel="noopener">Adatvédelmi tájékoztatót</a>, egyben hozzájárulok, hogy az e-mail címemre hasznos újdonságokat, tippeket és egyedi ajánlatokat küldjetek. *</span></label>'+
    '<div class="err" id="errEmail"'+(hiba?' style="display:block"':'')+'></div>'+
    '<div class="quiznav">'+backBtnHtml()+'<button class="btn" id="emailBtn" onclick="emailTovabb()" disabled>Tovább '+CTA_ARROW+'</button></div>';
  var qb=document.getElementById('qbox');
  qb.innerHTML=h; qb.style.display='block';
  if(hiba) document.getElementById('errEmail').textContent=hiba;
  var m=document.getElementById('emailLepesMezo');
  m.value=emailErtek; document.getElementById('optin').checked=emailOptin;
  emailEllenoriz();
  mentoForm();                                   // a captcha már most bekötődik, a Tovább-nál ne kelljen várni
  /* Telefonon NEM ugrunk bele a mezőbe: a felpattanó billentyűzet elfedné a
     képernyőt, és a vevő nem látná, mire iratkozik fel. (Lexi kérése, 2026-09-09) */
  if(window.matchMedia('(min-width:861px)').matches) m.focus();
}
function emailEllenoriz(){
  var m=document.getElementById('emailLepesMezo'), o=document.getElementById('optin');
  if(!m || !o) return;
  emailErtek=m.value.trim(); emailOptin=o.checked;
  document.getElementById('emailBtn').disabled = !(emailJo(emailErtek) && emailOptin);
}
function emailTovabb(){
  emailEllenoriz();
  var hiba=document.getElementById('errEmail');
  if(!emailJo(emailErtek)){ hiba.textContent='Kérlek adj meg egy érvényes e-mail címet.'; hiba.style.display='block'; return; }
  if(!emailOptin){ hiba.textContent='A továbblépéshez el kell fogadnod a fenti feltételeket.'; hiba.style.display='block'; return; }
  emailMentes();
  telefonLepes();
}
function telefonLepes(){
  document.getElementById('qbox').style.display='none';
  document.getElementById('gate').style.display='block';
  document.getElementById('email').value=emailErtek;       // a beküldött űrlap rejtett mezője
  var hiba=document.getElementById('errTel'); if(hiba) hiba.style.display='none';
  kvizFazis('gate');
  kvizMeres('kviz_telefon', {ag:purchase});
  var t=document.getElementById('telefon');
  if(t && window.matchMedia('(min-width:861px)').matches) t.focus();
}
function telefonVissza(){ if(felirMod() && linkEmail){ goBack(); return; } emailLepes(); }

/* ============================================================
   MENTÉS MÁR AZ E-MAIL LÉPÉSNÉL (Lexi, 2026-10-12)
   A Longevity Summiton többen az e-mail és az elfogadás után, a telefonszám előtt
   léptek ki, és mivel az űrlap csak a telefon-lépés végén ment be, az e-mailjük
   elveszett. Ezért a Tovább gombra a háttérben beküldünk egy második, rejtett
   hírlevél-űrlapot: az e-mail + a kvíz címkéi + `kviz-email-mentve`. A vevő így
   azonnal feliratkozó lesz, és a címkéi alapján a sorozata is elindul (Lexi döntése).
   A telefon-lépés a rendes kvizForm-mal megy tovább, ugyanarra az e-mailre: a
   Shopify a meglévő vevőre teszi rá a tel: címkét. A sorozatok szegmensbe lépésre
   indulnak, tehát a második beküldés nem küld újra levelet.

   A hCaptcha miatt (lásd movtech-form-ajax.js fejléc):
   - az űrlap a modalon KÍVÜL, a body végén ül, így a form-ajax nem veszi át, és a
     „Köszönjük" panel sem jön elő;
   - a captcha csak a már bekötött űrlapot engedi beküldeni, a bekötést pedig egy
     focusin indítja, ezért az e-mail lépés megjelenésekor kiváltjuk;
   - a captcha a végén a prototípus submit()-jével küld, ott vesszük át, és
     fetch-csel küldjük el: nincs oldal-újratöltés, nincs iframe.
   Bármilyen hiba esetén csendben feladjuk: a telefon-lépés beküldése úgyis megy,
   tehát a legrosszabb eset a korábbi működés.
   ============================================================ */
var mentettEmail='', mentesFolyik=false, mentesUtan=null, mentesSiker=false;
function mentoForm(){
  var f=document.getElementById('kvizMentoForm');
  if(f) return f;
  var eredeti=document.getElementById('kvizForm');
  if(!eredeti) return null;
  f=document.createElement('form');
  f.id='kvizMentoForm'; f.method='post'; f.acceptCharset='UTF-8';
  f.setAttribute('action', eredeti.getAttribute('action') || '/contact#kvizForm');
  f.style.display='none';
  f.innerHTML='<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">'+
    '<input type="hidden" name="contact[email]" value=""><input type="hidden" name="contact[tags]" value="">';
  document.body.appendChild(f);
  try{ f.elements['contact[email]'].dispatchEvent(new FocusEvent('focusin', {bubbles:true})); }catch(e){}
  return f;
}
function mentesVege(siker){
  mentesFolyik=false; mentesSiker=!!siker;
  if(siker) kvizMeres('kviz_email_mentve', {ag:purchase});
  var k=mentesUtan; mentesUtan=null;
  if(k) k();
}
function emailMentes(){
  if(felirMod() && linkEmail) return;            // a hírlevél-linkről jövő már feliratkozó
  if(mentesFolyik || emailErtek===mentettEmail) return;
  var f=mentoForm();
  if(!f) return;
  f.elements['contact[email]'].value=emailErtek;
  f.elements['contact[tags]'].value=buildTags()+',kviz-email-mentve';
  mentettEmail=emailErtek; mentesFolyik=true; mentesSiker=false;
  var probalt=0;
  (function kuld(){
    // a captcha bekötése aszinkron (betölti a hCaptcha-t); legfeljebb 5 mp-et várunk rá
    if(!f.dataset.hcaptchaBound && probalt++<25){ setTimeout(kuld, 200); return; }
    try{ f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit', {bubbles:true, cancelable:true})); }
    catch(e){ mentesVege(false); }
  })();
  setTimeout(function(){ if(mentesFolyik) mentesVege(false); }, 20000);   // ne ragadjon be
}
(function(){
  var elozo=HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit=function(){
    if(this.id!=='kvizMentoForm') return elozo.apply(this, arguments);
    fetch(this.getAttribute('action'), {method:'POST', body:new FormData(this), headers:{Accept:'text/html'}, credentials:'same-origin'})
      .then(function(r){
        var ok=false;
        try{ ok=new URL(r.url).searchParams.get('customer_posted')==='true'; }catch(e){}
        mentesVege(ok);
      })
      .catch(function(){ mentesVege(false); });
  };
})();

/* Csak magyar mobilszám: 20, 30, 31, 50 vagy 70, utána 7 számjegy. A +36 előtag
   fix a mező előtt, de ha a vevő mégis beírja (36…, 06…), levágjuk. A feltűnően
   hamis számot (végig azonos számjegy, 1234567, 7654321) elutasítjuk. */
function telSzamjegyek(v){
  var d=String(v||'').replace(/\D/g,'');
  if(d.length===13 && d.indexOf('0036')===0) d=d.slice(4);                          // 0036 30 …
  if(d.length===11 && (d.indexOf('36')===0 || d.indexOf('06')===0)) d=d.slice(2);  // +36 30 … / 06 30 …
  return d;
}
function telJo(d){
  if(!/^(20|30|31|50|70)\d{7}$/.test(d)) return false;
  var t=d.slice(2);
  if(/^(\d)\1{6}$/.test(t)) return false;
  if('01234567890'.indexOf(t)>=0 || '09876543210'.indexOf(t)>=0) return false;
  return true;
}
function telFormaz(el){                                    // kilépéskor 30 123 4567 alakra
  if(telNemzetkozi(el.value)) return;
  var d=telSzamjegyek(el.value);
  if(d.length===9) el.value=d.slice(0,2)+' '+d.slice(2,5)+' '+d.slice(5);
}

/* Külföldi szám (Lexi, 2026-10-10). Csak ott él, ahol a sablonban országválasztó van
   (#telOrszag, ma a Longevity kvíz); a popup-kvízben nincs, ott minden marad a fenti
   magyar ellenőrzésen. A választott (vagy +-szal / 00-val beírt) országhívó nem 36:
   a szám nemzetközi alakja 8–15 számjegy, a belföldi 0 előtagot levágjuk.
   Visszaad: a teljes szám számjegyei (pl. 436641234567), vagy null, ha magyar az ág. */
function telNemzetkozi(v){
  var sel=document.getElementById('telOrszag');
  if(!sel) return null;
  var nyers=String(v||'').trim(), d=nyers.replace(/\D/g,''), orsz;
  if(nyers.charAt(0)==='+' || d.indexOf('00')===0){       // a vevő maga írta be a hívószámot
    if(d.indexOf('00')===0) d=d.slice(2);
    if(d.indexOf('36')===0) return null;
    return d;
  }
  orsz=String(sel.value||'36').replace(/\D/g,'');
  if(orsz==='36') return null;
  if(d.indexOf(orsz)===0 && d.length>orsz.length+7) d=d.slice(orsz.length);  // a hívószámot a mezőbe is beírta
  d=d.replace(/^0/,'');
  return orsz+d;
}
function telNemzetkoziJo(d){
  if(!/^[1-9]\d{7,14}$/.test(d)) return false;
  if(/^(\d)\1+$/.test(d.slice(-7))) return false;            // végig azonos számjegy
  return true;
}

/* ---- A válaszokból vevő-címkék ----
   A címke MAGA A VÁLASZ, előtag nélkül. Két megkötés:
   - a Shopify a contact[tags] mezőt vesszővel bontja, ezért vessző nem lehet a címkében,
   - a hosszú címke használhatatlan a vevő-listában, ezért 60 karakternél vágunk.
   A "Hol hallottál rólunk?" szabad szövegét ismert forrásokra képezzük le, hogy ne
   ezer egyedi címke keletkezzen; ami egyikre sem illik, az a leírt szöveggel megy fel. */
var FORRAS_MINTAK=[
  [/insta/i,'Instagram'],
  [/face|fb|messenger/i,'Facebook'],
  [/tiktok|tik tok/i,'TikTok'],
  [/youtube|ytube/i,'YouTube'],
  [/google|keres|neten|honlap|weboldal/i,'Google'],
  [/hírlev|hirlev|e-?mail|mailben/i,'Hírlevél'],
  [/orvos|gyógytorn|gyogytorn|masszőr|masszor|edző|edzo|terapeuta|szakember/i,'Szakember ajánlása'],
  [/ismerős|ismeros|barát|barat|család|csalad|ajánl|ajanl|kollég|kolleg|férj|ferj|feleség|feleseg/i,'Ismerős ajánlása'],
  [/vásár|vasar|kiállít|kiallit|expo|rendezvény|rendezveny|verseny|fesztivál|fesztival/i,'Rendezvény'],
  [/üzlet|uzlet|bolt|személyesen|szemelyesen|showroom/i,'Üzlet'],
  [/hirdet|reklám|reklam|kampány|kampany/i,'Hirdetés'],
  [/újság|ujsag|cikk|blog|podcast|rádió|radio|televízi|televizi/i,'Média']
];
function forrasCimke(s){
  for(var i=0;i<FORRAS_MINTAK.length;i++){ if(FORRAS_MINTAK[i][0].test(s)) return FORRAS_MINTAK[i][1]; }
  return s;
}
/* A vesszo a cimkek elvalasztoja, ezert szokozre csereljuk. A hossz alapbol 60
   karakter (ennyi bven eleg egy valasz-cimkehez), de a link-recept ennel hosszabb
   lehet: harom-negy szurovel 70-100 karakter. A Shopify-korlat 255, ezert a
   receptnek 250-et adunk. (Enelkul a recept vege levagodott: mérve 2026-09-09.) */
function tisztit(s, maxHossz){
  return String(s).replace(/,/g,' ').split(' ').filter(Boolean).join(' ').slice(0, maxHossz || 60).trim();
}
function datumMa(){
  var d=new Date();
  return d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate());
}
/* A vevőre EGYETLEN valódi címke kerül: `kviz`. A válaszok ideiglenes, `q:` előtagú
   címkékben utaznak, mert a Shopify hírlevél-űrlapja csak címkét fogad el. Ezeket egy
   Flow-munkafolyamat írja át a custom.kviz_* metamezőkbe, majd letörli őket. */
/* ============================================================
   A TERMÉKAJÁNLÓ LINK „RECEPTJE" EGY CÍMKÉBEN
   Az e-mailekben a gomb vevőnként más termékekre visz. A Shopify Email Egyéni
   Liquid blokkja a vevő METAMEZŐIT NEM LÁTJA, a CÍMKÉIT viszont igen (valódi
   küldéssel mérve, 2026-09-09), ezért a receptet címkébe tesszük.
   Alak:  kvizlink:target-ferfiaknak.goal-fajdalom.body-nyak-vall
   A kulcs előtagja (target- / goal- / body- / tech-) mondja meg, melyik szűrőhöz
   tartozik, így a feloldáshoz nem kell külön tábla.
   Rövid marad (~100 karakter), tehát belefér a címke 255-ös korlátjába; a kész,
   szűrő-azonosítós link nem férne bele (280+).
   ⚠ A címke-takarító (shopify-admin/kviz-cimke-takaritas.mjs) csak a "q:"
   kezdetűeket szedi le, ezt meghagyja. */
function linkRecept(){
  var r=[];
  for(const f of ['target','goal','testresz','technologia']){
    facets[f].forEach(function(v){
      var tabla=FACET_KULCS[f];
      var kulcs=(tabla && tabla[v]) ? tabla[v] : null;
      if(kulcs && r.indexOf(kulcs)===-1) r.push(kulcs);
    });
  }
  return r.join('.');
}
function buildTags(){
  /* Longevity Summit módban a vevő más fő címkét kap, és a válaszok `ls:` előtaggal
     mennek: a `q:`-ra tüzelő metamezős Flow így nem indul el, tehát a `kviz` címke
     sem kerül fel, és a kitöltő nem lép be a kvízes üdvözlő sorozatba. */
  /* A feliratkozói kvíz (/pages/kviz) saját címkét és kf: előtagot kap, ugyanazért, amiért a
     longevity: a q:-ra tüzelő Flow a végén felteszi a kviz címkét, és elindítaná a kvízes
     üdvözlő sorozatot. A kf: válaszokat a longevity-kviz-valaszok.mjs írja metamezőbe. */
  var foCimke = longMod() ? 'longevity-summit-kviz' : (felirMod() ? 'kviz-feliratkozo' : 'kviz');
  var elo = longMod() ? 'ls:' : (felirMod() ? 'kf:' : 'q:');
  var t = popupMod() ? [foCimke,'newsletter'] : [foCimke];
  if(valaszok.kinek)  t.push(elo+'kinek:'+valaszok.kinek);
  if(valaszok.nem)    t.push(elo+'nem:'+valaszok.nem);
  if(valaszok.cel)    t.push(elo+'cel:'+valaszok.cel);
  for(var i=0;i<valaszok.reszlet.length;i++) t.push(elo+'reszlet:'+valaszok.reszlet[i]);
  if(valaszok.forras) t.push(elo+'forras:'+valaszok.forras);
  if(valaszok.bftermek) t.push('bf26:'+tisztit(valaszok.bftermek, 95));   // BF 2026: a választott termék handle-je
  /* 2026-10-25 (Lexi): a választott termék NEVE a vevő custom.kviz_bf_termek metamezőjébe is bekerül
     (q: → „Kvíz válaszok metamezőbe” Flow, kf: → longevity-kviz-valaszok.mjs). Mindig küldjük, választás
     nélkül kötőjellel, mert a Flow-ban az üres metamező-írás megállítaná a további lépéseket. */
  if(!longMod()) t.push(elo+'bftermek:'+(valaszok.bftermekNev || '-'));
  /* Ajándék-ágon a dátum a megajándékozotté, nem a vevőé, ezért nem az ő adata megy fel.
     A két mezőt viszont MINDIG elküldjük, üres helyett kötőjellel: a Flow-ban az üres
     értékű metamező-írás hibára fut, és megállítja a további lépéseket (mérve 2026-08-23). */
  var vanSajatDatum = (birthMode!=='gift');
  t.push(elo+'ev:' + (vanSajatDatum && birth.y ? birth.y : '-'));
  t.push(elo+'szulinap:' + (vanSajatDatum && birth.m
    ? MONTHS[parseInt(birth.m,10)-1] + (birth.d ? '-'+parseInt(birth.d,10) : '')
    : '-'));
  t.push(elo+'datum:'+datumMa());
  var recept = longMod() ? '' : linkRecept();   // a longevity ág nem szűrt listára visz
  if(recept) t.push('kvizlink:' + recept);        // ebből épül az e-mail gombjának linkje
  var ki=[];
  for(var j=0;j<t.length;j++){
    var c=tisztit(t[j], t[j].indexOf('kvizlink:')===0 ? 250 : ((t[j].indexOf('bf26:')===0 || t[j].indexOf(elo+'bftermek:')===0) ? 100 : 60));
    if(c && ki.indexOf(c)===-1) ki.push(c);
  }
  return ki.join(',');
}

// a választott facetekből élő, előre-szűrt kollekció-URL
/* ⚠ A kvíz emberi feliratokkal dolgozik („Férfiaknak”, „Fej / arc”), a termékek
   szűrő-metamezőiben viszont KULCSOK vannak (target-ferfiaknak, body-fej-arc…).
   Mérve 2026-09-09: a Shopify a felirat-alakot IS elfogadja, ugyanannyi találatot
   ad mindkettő. Azért küldünk mégis kulcsot, mert az az adat valódi alakja, és
   így nem a Shopify egyeztetési jóindulatán múlik a szűrés. */
const FACET_KULCS = {
  target: {
    'Férfiaknak':'target-ferfiaknak', 'Nőknek':'target-noknek', 'Szakembereknek':'target-szakember'
  },
  goal: {
    'Fájdalom-csillapítás':'goal-fajdalom', 'Teljesítmény-fokozás':'goal-teljesitmeny',
    'Szépség & bőr':'goal-beauty', 'Jobb alvás':'goal-alvas', 'Stresszkezelés':'goal-stressz'
  },
  testresz: {
    'Fej / arc':'body-fej-arc', 'Nyak / váll':'body-nyak-vall', 'Hát / gerinc':'body-hat-gerinc',
    'Kar / csukló':'body-kar-csuklo', 'Has / csípő':'body-has-csipo', 'Comb / térd':'body-comb-terd',
    'Lábszár':'body-labszar', 'Lábfej / boka / talp':'body-labfej-boka'
  },
  technologia: {
    'Masszázspisztoly':'tech-masszazspisztoly', 'Kompresszió / nyirok':'tech-kompresszio',
    'Egyéb professzionális':'tech-profi', 'Vörösfény (RLT)':'tech-vorosfeny',
    'Hidegterápia':'tech-hideg', 'Hőterápia':'tech-ho', 'Köpöly / fascia':'tech-kopoly-fascia'
  }
};
/* ⚠ A bolt szuro-panelje 2026 ota GID-eket hasznal ertekkent
   (gid://shopify/FilterSettingGroup/...), nem a metamezo kulcsat. A kulcs
   (target-ferfiaknak) is szur, DE a jelolonegyzet csak a gid-re pipalodik be, es
   ha a vevo a panelen bepipal barmit, a kviz szurese elveszik, mert a form a
   pipalt negyzetekbol epul ujra.
   Ezert a kviz inditasakor a hatterben lekerjuk a kollekcio-oldalt, es a
   felirat -> gid tablat kiolvassuk belole. NEM egetjuk be: a gid-ek a bolt
   szuro-beallitasaival valtozhatnak, es egy elavult gid rosszabb, mint a kulcs.
   Ha a lekeres nem sikerul, marad a kulcs-alak: az legalabb helyesen szur. */
var FACET_GID = null;
function labelFelirat(l){
  var t = '';
  for(var i=0; i<l.childNodes.length; i++){
    if(l.childNodes[i].nodeType === 3) t += l.childNodes[i].textContent;   // csak a sima szoveg, a darabszam nem
  }
  t = t.trim();
  return t || l.textContent.replace(/\s+/g, ' ').trim();
}
/* Az eredmény gombjának linkjét újraszámolja. Azért kell külön, mert a gid-tábla
   a HÁTTÉRBEN töltődik be: a gomb először a kulcs-alakkal áll be (az is szűr), és
   amint a tábla megjön, átvált a gid-alakra, amire a szűrő-panel is bepipálódik. */
function resGombFrissit(){
  var gomb=document.getElementById('resBtn');
  if(!gomb) return;
  var kodElem=document.getElementById('resCode');
  var kod=kodElem ? (kodElem.textContent||'').trim() : '';
  gomb.setAttribute('href', kuponosUrl(kod));
}
function facetGidBetolt(){
  if(FACET_GID) return;                                   // egyszer eleg
  FACET_GID = {};
  try{
    fetch(FILTER_BASE, {credentials:'same-origin'})
      .then(function(r){ return r.ok ? r.text() : null; })
      .then(function(h){
        if(!h) return;
        var d = new DOMParser().parseFromString(h, 'text/html');
        var tabla = {};
        var dobozok = d.querySelectorAll('input[type=checkbox][name^="filter.p.m.custom."]');
        for(var i=0; i<dobozok.length; i++){
          var cb = dobozok[i];
          var l = cb.id ? d.querySelector('label[for="' + cb.id + '"]') : null;
          if(!l || !cb.value) continue;
          var f = cb.name.replace('filter.p.m.custom.', '');
          if(!tabla[f]) tabla[f] = {};
          tabla[f][labelFelirat(l)] = cb.value;
        }
        FACET_GID = tabla;
        resGombFrissit();                 // ha az eredmény már látszik, a link átvált a gid-alakra
      })
      .catch(function(){});
  }catch(e){}
}
function facetKulcs(f, ertek){
  var g = FACET_GID && FACET_GID[f] && FACET_GID[f][ertek];
  if(g) return g;                                   // a szuro-panel csak erre pipal be
  var t = FACET_KULCS[f];
  return (t && t[ertek]) ? t[ertek] : ertek;      // ismeretlen érték: marad, hogy ne tűnjön el némán
}
function buildFilterUrl(){
  const parts=[];
  for(const f of ['target','goal','testresz','technologia']){
    facets[f].forEach(v=> parts.push('filter.p.m.custom.'+f+'='+encodeURIComponent(facetKulcs(f, v))));
  }
  return FILTER_BASE + (parts.length? '?'+parts.join('&') : '');
}
/* A szurt lista URL-je a kuponnal egyutt.
   ⚠ NE a /discount/KOD?redirect=... alakot hasznaljuk: a Shopify a redirect
   celjabol LEDOBJA a query stringet, tehat a szuro elveszik, es a vevo a teljes
   /collections/all listat kapja. Merve 2026-09-09 elesben, mindket kodolassal.
   A ?discount=KOD parameter viszont barmelyik storefront URL-en mukodik: a
   kedvezmeny ugyanugy bekerul (discount_code suti), es a szuro megmarad. */
function kuponosUrl(kod){
  var u = buildFilterUrl();
  if(!kod) return u;
  return u + (u.indexOf('?')>=0 ? '&' : '?') + 'discount=' + encodeURIComponent(kod);
}
const FACET_LABEL={target:'Kinek',goal:'Cél',testresz:'Testrész',technologia:'Technológia'};
/* Aki egyszer végigment a kvízen, annak a popup nem jön elő újra, és naponta
   legfeljebb a megengedett számú felugró ablak jelenhet meg. MINDKÉT SZABÁLY
   a MOVTECH ajánlatok appban él (window.mvtPopupSzabaly), hogy egy helyen legyen
   és ne akadjon össze a téma saját logikájával. Itt csak kérdezünk és jelentünk. */
function popupKapu(){
  return window.mvtPopupSzabaly || null;
}
/* A TÉMA SAJÁT TRIGGERE — 2026-09-22, javítás.
   A téma hírlevél-popupja magától is felnyílik (70% görgetés + 4 mp tétlenség,
   section-newsletter-popup.js → initScrollTrigger), és EZT az app szabálya nem
   látja: a téma csak a saját sütijeit nézi (shouldBlockPopupAutoTrigger).
   Emiatt a kvíz-popup annak is felugrott, aki már kitöltötte (mérve élesben).
   Ezért amit a kapu eldönt, azt a téma nyelvén, sütivel is kimondjuk:
     - kitöltötte → newsletter_popup_success (a téma ezt teszi le beküldéskor is)
     - a napi keret betelt → newsletter_popup_hidden 1 napra
   A saját nyitásunkat (createPopup) egyik süti sem akadályozza, csak a téma
   automatikus triggerét. */
function sutiTesz(nev, nap){
  try{
    var d=new Date();
    d.setTime(d.getTime() + nap*86400000);
    document.cookie = nev + '=true; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }catch(e){}
}
function temaTriggerTiltas(vegleges){
  if(vegleges) sutiTesz('newsletter_popup_success', 365);   // kitöltötte: soha többé
  else sutiTesz('newsletter_popup_hidden', 1);              // mára betelt a napi keret
}
function kitoltveJelol(){
  var kapu = popupKapu();
  if(kapu) kapu.kesz('kviz');
  temaTriggerTiltas(true);            // a téma saját triggerét is elnémítjuk
}
/* ============================================================
   KUPON-VISSZASZÁMLÁLÓ — az utalvány a kiállítástól számított egy hétig él.
   A kezdést a böngészőben tároljuk, hogy visszatéréskor ne induljon újra a hét.
   ⚠ Ez a határidő CSAK a kijelzőn él: a movkviz35k kuponnak a boltban nincs
   lejárata (endsAt: null, mérve 2026-09-09). Ha a kommunikált egy hetet
   valóssá tesszük, a kupon endsAt mezőjét is állítani kell.
   ============================================================ */
const KUPON_NAP = 7;
const KUPON_KEZDET_KULCS = 'movtech_kviz_kupon_kezdet';
var kuponOraTimer = null;
function kuponHatarido(){
  /* Ha a sablon megadja a valódi lejáratot (data-veg a #kuponOra elemen, ISO dátum),
     azt mutatjuk: a Longevity Summit kártyája fix napon jár le, nem a kiállítástól
     számított egy hét múlva. Enélkül marad a régi, böngészőben tárolt hetes logika. */
  var doboz = document.getElementById('kuponOra');
  var fix = doboz ? doboz.getAttribute('data-veg') : null;
  if(fix){
    var ido = Date.parse(fix);
    if(!isNaN(ido)) return ido;
  }
  var t = 0;
  try{ t = parseInt(localStorage.getItem(KUPON_KEZDET_KULCS) || '0', 10) || 0; }catch(e){}
  if(!t){
    t = Date.now();
    try{ localStorage.setItem(KUPON_KEZDET_KULCS, String(t)); }catch(e){}
  }
  return t + KUPON_NAP * 24 * 60 * 60 * 1000;
}
function ketJegy(n){ return n < 10 ? '0' + n : String(n); }
function kuponOraFrissit(){
  var doboz = document.getElementById('kuponOra');
  if(!doboz) return;
  var hatra = kuponHatarido() - Date.now();
  if(hatra < 0) hatra = 0;
  var nap  = Math.floor(hatra / 86400000);
  var ora  = Math.floor(hatra / 3600000) % 24;
  var perc = Math.floor(hatra / 60000) % 60;
  var mp   = Math.floor(hatra / 1000) % 60;
  var e;
  if((e = document.getElementById('koNap')))  e.textContent = nap;
  if((e = document.getElementById('koOra')))  e.textContent = ketJegy(ora);
  if((e = document.getElementById('koPerc'))) e.textContent = ketJegy(perc);
  if((e = document.getElementById('koMp')))   e.textContent = ketJegy(mp);
  doboz.classList.toggle('lejart', hatra === 0);
}
function kuponOraIndit(){
  if(!document.getElementById('kuponOra')) return;
  kuponOraFrissit();
  if(kuponOraTimer) clearInterval(kuponOraTimer);
  kuponOraTimer = setInterval(kuponOraFrissit, 1000);
}
/* ============================================================
   LONGEVITY SUMMIT MÓD (Lexi, 2026-09-20)
   Ugyanez a kvíz fut a /pages/longevity-summit-kviz oldalon, három eltéréssel:
   1. a vevő a `longevity-summit-kviz` címkét kapja a `kviz` helyett, és a válaszok
      `ls:` előtaggal mennek fel. Így a „Kvíz válaszok metamezőbe" Flow (az a `q:`
      címkékre tüzel, és a végén felteszi a `kviz` címkét) NEM indul el, tehát a
      longevity kitöltő nem kerül a kvízes szegmensbe és az üdvözlő sorozatba.
   2. az eredmény nem szűrt terméklista, hanem a Longevity Summit csomagok (2026-09-24 óta 6)
      relevancia-sorrendben. A kártyákat a sablon rendereli, itt csak pontozunk.
   3. saját kuponkód (movlongevity35k), a sablon #resCode elemében.
   A kérdések, az ágak és az utalvány-számláló mindenben azonos a rendes kvízzel.
   ============================================================ */
function longMod(){ return window.MOVTECH_KVIZ_MOD === 'longevity'; }
function felirMod(){ return window.MOVTECH_KVIZ_MOD === 'feliratkozo'; }

/* A pontozás kulcsai maguk a VÁLASZ-CÍMKÉK (a tags tömb elemei), hogy egy helyen
   lássuk, mitől lesz releváns egy csomag. Ismeretlen címke nem ér pontot, és
   döntetlennél a sablonbeli (ár szerinti) sorrend marad. */
const LONG_PONT = {
  'full-body-red-light-matrac-csomag-longevity': {
    'Longevity & biohacking':4, 'Sejtregeneráció':5, 'Gyulladáscsökkentés':4,
    'Stresszkezelés':3, 'Jobb alvás':3, 'Haladó biohacker':2, 'Kezdő':1,
    'Vörösfény terápia':5, 'Testen':3, 'Arcon és testen':1,
    'Hát / gerinc':3, 'Has / csípő':2, 'Comb / térd':2, 'Lábszár':2, 'Nyak / váll':1,
    'Teljesítmény-fokozás':2, 'Fájdalom-csillapítás':2, 'Krónikus':2,
    'Edzés után':2, 'Edzőterem / erősport / állóképesség':1, 'Futás':1, 'Masszázspisztoly':1
  },
  'elit-masszazspisztoly-akcio-longevity': {
    'Fájdalom-csillapítás':4, 'Teljesítmény-fokozás':4, 'Masszázspisztoly':5,
    'Nyak / váll':4, 'Hát / gerinc':3, 'Comb / térd':3, 'Kar / csukló':3, 'Lábszár':3,
    'Lábfej / boka / talp':2, 'Has / csípő':1,
    'Akut':2, 'Krónikus':2, 'Visszatérő':2,
    'Edzés előtt':3, 'Edzés után':3, 'Edzés előtt és után':3,
    'Edzőterem / erősport / állóképesség':2, 'Futás':2, 'Kerékpározás':2, 'Úszás':2,
    'Futball':2, 'Kézilabda / kosárlabda / röplabda':2, 'Tenisz / asztalitenisz / padel / squash':2,
    'Küzdősport':2, 'Extrém sport':2, 'Vegyes / egyéb sport':2,
    'Szakember':3, 'Saját rendelő':2, 'Klinika / csapat':2, 'Edzőterem / egyesület':2,
    'Mobil szolgáltatás':3, 'Fascia kés / köpölyöző':1, 'Hőterápia':1, 'Kezdő':1
  },
  'vorosfeny-180-panel-csomag-longevity': {
    'Vörösfény terápia':5, 'Sejtregeneráció':4, 'Gyulladáscsökkentés':3,
    'Longevity & biohacking':3, 'Szépség & bőr':3,
    'Öregedésgátlás':2, 'Ragyogás':2, 'Bőrfeszesség':2,
    'Arcon és testen':3, 'Testen':2, 'Arcon':1,
    'Stresszkezelés':2, 'Jobb alvás':2, 'Haladó biohacker':2,
    'Teljesítmény-fokozás':2, 'Edzés után':1, 'Nyak / váll':1, 'Hát / gerinc':1,
    'Szakember':2, 'Saját rendelő':2, 'Klinika / csapat':2, 'Masszázspisztoly':1
  },
  'kompresszios-csomag-longevity': {
    'Nyirokmasszázs terápia':5, 'Keringés és nyirok':5,
    'Lábszár':5, 'Comb / térd':4, 'Lábfej / boka / talp':4, 'Has / csípő':1,
    'Teljesítmény-fokozás':3, 'Edzés után':3, 'Edzés előtt és után':2,
    'Futás':3, 'Kerékpározás':3, 'Edzőterem / erősport / állóképesség':2, 'Futball':2,
    'Kézilabda / kosárlabda / röplabda':2, 'Tenisz / asztalitenisz / padel / squash':2,
    'Extrém sport':1, 'Úszás':1, 'Küzdősport':1, 'Vegyes / egyéb sport':1,
    'Jobb alvás':2, 'Cellulit':2, 'Fájdalom-csillapítás':2, 'Krónikus':1,
    'Longevity & biohacking':2, 'Szakember':2, 'Saját rendelő':2, 'Klinika / csapat':2,
    'Edzőterem / egyesület':2, 'Masszázspisztoly':1
  },
  'szepsegapolasi-csomag-longevity': {
    'Szépség & bőr':5, 'Öregedésgátlás':4, 'Ragyogás':4, 'Bőrfeszesség':4,
    'Problémás bőr':4, 'Cellulit':1,
    'Arcon':5, 'Arcon és testen':2, 'Fej / arc':4, 'Nő':2,
    'Vörösfény terápia':3, 'Sejtregeneráció':2, 'Longevity & biohacking':1, 'Kezdő':1
  },
  /* 2026-09-24: Recovery Tub Pro (Oval / Round) + ajándék Pro+ pisztoly */
  'recovery-tub-pro-csomag-longevity': {
    'Hidegterápia':5, 'Jeges merülés':5, 'Gyulladáscsökkentés':4, 'Longevity & biohacking':3,
    'Haladó biohacker':3, 'Stresszkezelés':3, 'Jobb alvás':2, 'Sejtregeneráció':1,
    'Teljesítmény-fokozás':3, 'Edzés után':3, 'Edzés előtt és után':2,
    'Edzőterem / erősport / állóképesség':3, 'Futás':2, 'Kerékpározás':2, 'Futball':2,
    'Kézilabda / kosárlabda / röplabda':2, 'Küzdősport':2, 'Extrém sport':2, 'Úszás':1, 'Vegyes / egyéb sport':1,
    'Comb / térd':2, 'Lábszár':2, 'Lábfej / boka / talp':1, 'Fájdalom-csillapítás':1, 'Akut':1,
    'Szakember':2, 'Klinika / csapat':3, 'Edzőterem / egyesület':3, 'Masszázspisztoly':1
  }
};

function longPontoz(handle){
  var tabla = LONG_PONT[handle] || {};
  var ossz = 0;
  for(var i=0;i<tags.length;i++){ var p = tabla[tags[i]]; if(p) ossz += p; }
  return ossz;
}

/* A sablon mind az 5 csomagot kirendereli (ár szerinti sorrendben); itt csak
   átrendezzük őket a pontszám szerint, és az elsőt megjelöljük. A pontszámot nem
   mutatjuk meg: az ajánlás sorrendje az üzenet, nem a szám. */
function longCsomagokRendez(){
  var lista = document.getElementById('lcsomagok');
  if(!lista) return;
  var elemek = Array.prototype.slice.call(lista.querySelectorAll('[data-handle]'));
  if(!elemek.length) return;
  for(var i=0;i<elemek.length;i++) elemek[i].setAttribute('data-alap', i);
  elemek.sort(function(a,b){
    var kulonbseg = longPontoz(b.getAttribute('data-handle')) - longPontoz(a.getAttribute('data-handle'));
    if(kulonbseg) return kulonbseg;
    return parseInt(a.getAttribute('data-alap'),10) - parseInt(b.getAttribute('data-alap'),10);
  });
  for(var j=0;j<elemek.length;j++){
    if(j===0) elemek[j].classList.add('elso'); else elemek[j].classList.remove('elso');
    var jel = elemek[j].querySelector('[data-elso-jel]');
    if(jel) jel.hidden = (j!==0);
    lista.appendChild(elemek[j]);
  }
}

/* A csomag-linkekre ugyanúgy rákerül a kupon, mint a rendes kvíz gombjára:
   ?discount=<kod> (a /discount/<kod>?redirect=… alak ledobná a paramétereket). */
function longKuponLinkek(){
  var kodElem = document.getElementById('resCode');
  var kod = kodElem ? (kodElem.textContent||'').trim() : '';
  if(!kod) return;
  var linkek = document.querySelectorAll('#lcsomagok a[data-termek-link]');
  for(var i=0;i<linkek.length;i++){
    var alap = (linkek[i].getAttribute('href')||'').split('?')[0];
    if(alap) linkek[i].setAttribute('href', alap + '?discount=' + encodeURIComponent(kod));
  }
}

function showResult(){
  kitoltveJelol();                    // innentől nem kell neki a popup
  kvizMeres('kviz_kitoltve', {ag:purchase});
  /* ⚠ Beküldés után az oldal ÚJRATÖLTŐDIK, a kvíz nem indul újra, tehát a
     startQuiz-beli gid-lekérés nem futott le. Enélkül a gomb a kulcs-alakot
     kapja: a lista szerver-oldalon jól szűr, DE a szűrő-panel nem pipálódik be,
     és a téma a betöltés után a pipált négyzetekből újraszűr — így a vevő a
     teljes listát látja. Mérve élesben 2026-09-09: 50 termék 28 helyett. */
  if(!longMod()) facetGidBetolt();       // longevity módban nincs szűrt lista, nem kell a gid-tábla
  kvizFazis('eredmeny');
  ajandekFeliratok();
  document.getElementById('gate').style.display='none';
  document.getElementById('result').style.display='block';
  kuponOraIndit();                    // az egyhetes visszaszámláló
  /* Beküldés után az oldal újratöltődik, a step nullázódik: az utalvány itt már
     teljes, ezért csendben (felszámolás és buborék nélkül) állítjuk be. */
  egyenlegFrissit(true, true);
  /* TŰZIJÁTÉK-HANG: ha kattintásból jövünk, a böngésző engedi az audiót. */
  try{
    if(window.MovtechSFX){
      MovtechSFX.enabled=true; MovtechSFX.volume=0.75;
      MovtechSFX.play('firework');
      [370,730,1100,1480,1850].forEach(function(d){ setTimeout(function(){ try{MovtechSFX.play('firework');}catch(e){} }, d); });
    }
  }catch(e){}
  /* ~2 másodperces tűzijáték + konfetti */
  try{
    if(window.MovtechFX){
      MovtechFX.fireworks({count:13, windowMs:2000, sound:false});
      MovtechFX.confetti({count:170});
      setTimeout(function(){ try{ MovtechFX.confetti({count:120}); }catch(e){} }, 850);
      setTimeout(function(){ try{ MovtechFX.confetti({count:110}); }catch(e){} }, 1550);
    }
  }catch(e){}
  const chips=[];
  for(const f of ['target','goal','testresz','technologia']){
    facets[f].forEach(v=> chips.push('<span class="chip"><b>'+FACET_LABEL[f]+':</b> '+v+'</span>'));
  }
  document.getElementById('resChips').innerHTML = chips.join('');
  if(longMod()){                       // az 5 csomag relevancia-sorrendben, szűrt lista helyett
    longCsomagokRendez();
    longKuponLinkek();
  }
  var eredmenyGomb = document.getElementById('resBtn');
  if(eredmenyGomb) eredmenyGomb.href = buildFilterUrl();
}
document.addEventListener('keydown',function(e){
  if(e.key==='Escape') closeQuiz();
});

/* A hírlevél-popup markupja `<template class="lazy-template-modal">`-ben van, és csak
   a megnyitáskor kerül a DOM-ba. A kvízt ezért a téma modal:opened eseményére építjük fel. */
document.addEventListener('modal:opened', function(){
  var popup = document.getElementById('kvizPopup');
  if(!popup) return;
  var intro = document.getElementById('kvizIntro');
  if(intro && !document.querySelector('#qbox .qtitle')){
    intro.style.display='';                                  // nyitóblokk, gombra indul
    var pw=document.getElementById('progwrap'); if(pw) pw.style.display='none';
  }
});

/* ---- Movtech gamifikációs hangok (hover=csempés pop, klikk=click) ---- */
(function(){
  if(!window.MovtechSFX) return;
  MovtechSFX.volume = 0.5;
  var lastHov=null;
  document.addEventListener('pointerover',function(e){
    var el=e.target.closest && e.target.closest('.ans,.btn,.closex,.reslist a');
    if(el){ if(el!==lastHov){ lastHov=el; MovtechSFX.play('pop'); } } else { lastHov=null; }
  });
  document.addEventListener('click',function(e){
    if(e.target.closest && e.target.closest('.ans,.btn,.closex,.reslist a')) MovtechSFX.play('click');
  }, true);
})();

/* ============================================================
   AZ E-MAIL LÉPÉS BEKÜLDÉSE
   A Shopify `customer` (hírlevél) űrlapját küldjük be, a rejtett
   `contact[tags]` mezőben a kvízből számolt címkékkel. A vevő így az
   e-mail címe alapján megkapja őket, külső rendszer nélkül.

   A beküldés a GYÁRI úton megy: rendes űrlap-beküldés, oldal-újratöltéssel.
   Így a bolton bekapcsolt Shopify hCaptcha érintetlenül lefut (a fetch-es
   átvétel a captcha kihívásán elakadt). Az újratöltés nem zavarja a
   felhasználót: a kvíz állapotát beküldés előtt elmentjük, a Shopify pedig
   a `customer_posted=true` paraméterrel hoz vissza, amire azonnal az
   eredményt mutatjuk.
   ============================================================ */
(function(){
  var KULCS='movtechKvizAllapot';

  function allapotMent(){
    try{
      sessionStorage.setItem(KULCS, JSON.stringify({
        facets: facets, tags: tags, sourceVal: sourceVal, lepesek: flow.length,
        birth: birth, birthMode: birthMode, purchase: purchase, ido: new Date().getTime()
      }));
    }catch(e){}
  }

  function allapotVissza(){
    try{
      var nyers=sessionStorage.getItem(KULCS);
      if(!nyers) return false;
      sessionStorage.removeItem(KULCS);
      var a=JSON.parse(nyers);
      if(!a || !a.facets) return false;
      facets=a.facets; tags=a.tags||[]; sourceVal=a.sourceVal||'';
      if(a.birth) birth=a.birth;
      if(a.birthMode) birthMode=a.birthMode;
      if(a.purchase) purchase=a.purchase;           // ajándék-ágon a záró szövegekhez
      return true;
    }catch(e){ return false; }
  }

  /* A popupban az űrlapot a movtech-form-ajax.js küldi be (nincs oldal-újratöltés),
     és alapból az általános „Köszönjük…" panelt mutatná. Itt átvesszük: a kvíz saját
     eredmény-képernyője jön, tűzijátékkal és a kuponra kötött gombbal. */
  document.addEventListener('movtech:form-success', function(e){
    var f=e.target;
    if(!f || f.id!=='kvizForm') return;
    e.preventDefault();                                   // az általános panel elmarad
    try{ sessionStorage.removeItem(KULCS); }catch(err){}  // ne nyíljon ki újra egy későbbi újratöltéskor
    fxBetolt(function(){ showResult(); kuponraKotGomb(); });
  });

  document.addEventListener('submit', function(e){        // capture: a captcha előtt futunk
    var f=e.target;
    if(f && f.id==='kvizForm'){
      /* A telefonszám ellenőrzése a beküldés előtt. Hibás számnál a captcha el sem
         indul: a capture-fázisban állunk meg, mielőtt az űrlap saját kezelője futna. */
      var tm=document.getElementById('telefon');
      if(tm){
        var kulf=telNemzetkozi(tm.value), hiba=document.getElementById('errTel');
        var d=kulf || telSzamjegyek(tm.value);
        if(hiba && !hiba.getAttribute('data-hu')) hiba.setAttribute('data-hu', hiba.textContent);
        if(kulf ? !telNemzetkoziJo(d) : !telJo(d)){
          e.preventDefault(); e.stopImmediatePropagation();
          if(hiba){
            hiba.textContent = kulf ? 'Ez nem tűnik érvényes telefonszámnak. Kérlek, ellenőrizd az országot és a számot.' : hiba.getAttribute('data-hu');
            hiba.style.display='block';
          }
          tm.focus();
          return;
        }
        if(hiba) hiba.style.display='none';
        var sms=document.getElementById('smsOptin');
        /* Ha az e-mail lépés mentése ugyanerre a címre sikerült, a kvíz-címkék már a vevőn vannak:
           itt csak a telefonszám megy, így csak az SMS-Flow fut (Lexi, 2026-10-12). A szöveget a Flow
           ilyenkor a vevő fő címkéjéből választja (longevity-summit-kviz / kviz-feliratkozo / popup).
           Ha a mentés nem ment át, minden címke itt megy, ahogy korábban. */
        var csakTel = mentesSiker && mentettEmail===document.getElementById('email').value;
        document.getElementById('kvizTags').value = (csakTel ? '' : buildTags() + ',') + 'tel:+' + (kulf ? '' : '36') + d + (sms && sms.checked ? ',sms-marketing' : '');
        if(!document.getElementById('email').value) document.getElementById('email').value=emailErtek;
      }
      /* Ha az e-mail lépés háttér-mentése még fut, megvárjuk: két captcha egyszerre
         összeakadhat. A mentés végén (legkésőbb 20 mp) újra beküldjük ugyanezt. */
      if(mentesFolyik){
        e.preventDefault(); e.stopImmediatePropagation();
        mentesUtan=function(){ f.requestSubmit ? f.requestSubmit() : f.submit(); };
        return;
      }
      allapotMent();
      kvizMeres('kattintas', {cel:'feliratkozas'});
    }
  }, true);

  function ujranyit(){
    overlayNyit();
    var modal = document.querySelector('newsletter-modal-popup');
    if(modal){                                   // popup-mód: a téma modalját nyitjuk
      modal.classList.add('active');
      modal.classList.remove('invisible','content-hidden');
      document.documentElement.classList.add('open-modal');
    }
    /* A nyitóképernyő (cím, kártyakép, Kezdem gomb) itt már nem kell: beküldés után az
       eredmény jön. A popup markupjában ez az elem a lapon marad, ezért kézzel rejtjük,
       különben a nagy utalvány FÖLÖTT látszana (mérve 2026-09-20 a longevity kvízen). */
    var introElem=document.getElementById('kvizIntro');
    if(introElem) introElem.style.display='none';
    document.getElementById('progwrap').style.display='block';
    document.getElementById('progfill').style.width='100%';
    document.getElementById('progpct').textContent='100%';
    document.getElementById('progtxt').textContent='Kész';
    document.getElementById('qbox').style.display='none';
  }

  /* Beküldés után az oldal újratöltődik. A Shopify visszairányítása NEM mindig hozza
     magával a customer_posted paramétert (mérve 2026-08-21-én: a címkék felkerültek,
     de a paraméter nélkül a kvíz az elejéről indult, és a felhasználó nem látta az
     eredményt). Ezért maga a friss mentés a jelzés: ha van, a beküldés megtörtént. */
  function frissMentes(){
    try{
      var nyers=sessionStorage.getItem(KULCS);
      if(!nyers) return false;
      var a=JSON.parse(nyers);
      if(!a || !a.ido) return true;                       // időbélyeg nélküli régi mentés
      return (new Date().getTime() - a.ido) < 600000;     // 10 percen belül
    }catch(e){ return false; }
  }

  if(document.getElementById('kvizFormHiba')){
    // A Shopify elutasította a beküldést (pl. hibás cím): a válaszok megvannak,
    // a felhasználó az e-mail lépésnél folytathatja, a hibaüzenettel a szeme előtt.
    if(allapotVissza()){
      ujranyit();
      document.getElementById('kvizTags').value=buildTags();
      ajandekFeliratok();
      /* A hiba szinte mindig az e-mail címről szól, ezért az e-mail lépés nyílik
         vissza, a Shopify üzenetével. (A telefon-lépésen nincs látható e-mail mező.) */
      var sh=document.getElementById('kvizFormHiba');
      emailLepes(sh ? sh.textContent.replace(/\s+/g,' ').trim() : '');
      if(sh) sh.style.display='none';
    }
  } else if(frissMentes() && allapotVissza()){
    facetGidBetolt();                          // minél előbb induljon: a gomb erre vált át
    if(document.getElementById('result')){       // landing: saját eredmény-képernyő
      ujranyit();
      fxBetolt(function(){ showResult(); kuponraKotGomb(); });
    } else if(popupSablonbolNyit()){             // popup: beküldés után a sablonból építjük újra
      fxBetolt(function(){ showResult(); kuponraKotGomb(); });
    } else {                                     // végszükség: a téma kupon-popupja
      kuponGombSzemelyre();
    }
  }

  /* Beküldés után a téma már nem építi fel a hírlevél-popupot (a feliratkozás
     megtörtént), így a kvíz eredmény-képernyője sehol nem lenne a lapon. Ezért a
     popup sablonjából kimásoljuk a kvíz dobozát egy saját rétegbe, és abban
     mutatjuk meg az eredményt, ugyanúgy, mint a landing oldalon. */
  function popupSablonbolNyit(){
    var sablonok=document.querySelectorAll('template'), doboz=null;
    for(var i=0;i<sablonok.length && !doboz;i++){
      try{ doboz=sablonok[i].content.querySelector('#kvizPopup'); }catch(e){}
      if(doboz && sablonok[i].parentNode) sablonok[i].parentNode.removeChild(sablonok[i]);  // ne épülhessen fel másodszor
    }
    if(!doboz) return false;
    var reteg=document.createElement('div');
    reteg.className='mvt-kviz-utolag';
    var masolat=doboz.cloneNode(true);
    reteg.appendChild(masolat);
    var zar=document.createElement('button');
    zar.type='button'; zar.className='kvizzar'; zar.setAttribute('aria-label','Bezárás');
    zar.innerHTML='<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 4l16 16M20 4L4 20"/></svg>';
    zar.onclick=function(){ if(reteg.parentNode) reteg.parentNode.removeChild(reteg); document.documentElement.classList.remove('open-modal'); };
    masolat.appendChild(zar);
    document.body.appendChild(reteg);
    mvtKartyaRajzol(reteg);                          // az utalványkép canvasra (LCP)
    document.documentElement.classList.add('open-modal');
    temaKuponPopupZar();
    var pw=document.getElementById('progwrap');
    if(pw){
      pw.style.display='block';
      document.getElementById('progfill').style.width='100%';
      document.getElementById('progpct').textContent='100%';
      document.getElementById('progtxt').textContent='Kész';
    }
    var intro=document.getElementById('kvizIntro'); if(intro) intro.style.display='none';
    var qb=document.getElementById('qbox'); if(qb) qb.style.display='none';
    return true;
  }

  /* A téma saját kupon-popupja ilyenkor felesleges: ugyanazt a kódot mutatná. */
  function temaKuponPopupZar(){
    var probak=0;
    var ora=setInterval(function(){
      var d=document.querySelector('discount-modal-popup');
      if(d && d.parentNode){ d.parentNode.removeChild(d); clearInterval(ora); }
      if(++probak>60) clearInterval(ora);
    },100);
  }

  /* Az eredmény gombja a kuponnal együtt visz tovább: a kedvezmény magától
     bekerül a kosárba, és rögtön a szűrt terméklista jön. A kódot az eredmény
     dobozából olvassuk ki, hogy a sablonban lehessen cserélni. */
  function kuponraKotGomb(){
    var gomb=document.getElementById('resBtn'), kodElem=document.getElementById('resCode');
    if(!gomb || !kodElem) return;
    var kod=(kodElem.textContent||'').trim();
    if(kod) gomb.href=kuponosUrl(kod);
  }

  /* A kupon-popup is sablonból épül fel, ezért megvárjuk, amíg a gomb megjelenik,
     és a kedvezmény-link átirányítását a kvíz szűrt terméklistájára cseréljük. */
  function kuponGombSzemelyre(){
    var probak = 0;
    var ora = setInterval(function(){
      var gomb = document.querySelector('discount-modal-popup a[href*="/discount/"]');
      if(gomb){
        /* A sablon linkje /discount/<kod> alaku; a kodot kiszedjuk belole, es a
           szurt listara mutato, ?discount=... vegu cimre csereljuk. */
        var alap = gomb.getAttribute('href').split('?')[0];
        var kod = alap.split('/').pop();
        gomb.setAttribute('href', kuponosUrl(decodeURIComponent(kod)));
        clearInterval(ora);
      }
      if(++probak > 60) clearInterval(ora);      // 6 másodperc után feladjuk
    }, 100);
  }
})();

/* ============================================================
   MIKOR NYÍLJON A POPUP
   A téma gyári logikája (70% görgetés + 4 mp tétlenség) helyett az oldalon
   eltöltött idő számít: az oldal betöltésétől 15 másodperc. A popup markupja egy
   <template>-ben van, a szekció JS-e pedig csak az első interakciónál töltődne be,
   ezért mindkettőt magunk készítjük elő, majd a téma saját createPopup()-jával
   nyitjuk meg (így a bezárás, a fókusz és a sütik ugyanúgy működnek).
   ============================================================ */
function kvizSablon(){
  var sablonok=document.querySelectorAll('template');
  for(var i=0;i<sablonok.length;i++){
    try{ if(sablonok[i].content.querySelector('#kvizPopup')) return sablonok[i]; }catch(e){}
  }
  return null;
}
(function(){
  var IDO = 7000;                  // ennyit kell az oldalon tölteni (Lexi 2026-09-18: hamarabb, több leadért)
  var ELOKESZITES = 3000;          // ekkor építjük fel a popupot a háttérben (a nyitás előtt bőven)
  var UJRAPROBA = 4000;            // ha épp más ablak van nyitva

  var landingOldal = !!document.getElementById('kvizPopup');   // induláskor: a kvíz már a lapon van

  /* KOSÁRBA TÉTEL KÖZBEN NEM UGRIK FEL (2026-09-28)
     Mobilon a kosárba tétel és a kosár-fiók megnyitása 2-3 mp. Ha a 7 mp-es
     időzítő ebbe az ablakba esett, a kvíz nyílt meg a kosár helyett, a fiók és a
     kosár-ajánlat pedig elmaradt: a vevő úgy látta, beakadt a rendelés. Aki ezen
     az oldalon már kosárba tett valamit, annak itt nem nyitjuk meg a kvízt. */
  var vasarol = false;
  function vasarlasJel(){ vasarol = true; }
  document.addEventListener('submit', function(e){
    var a = e.target && e.target.getAttribute && (e.target.getAttribute('action') || '');
    if(a.indexOf('/cart/add') >= 0) vasarlasJel();
  }, true);
  document.addEventListener('click', function(e){
    var t = e.target && e.target.closest && e.target.closest('[name="add"], .product-form__submit, .mvt-ajanlat__gomb, a[href*="/cart"], a[href*="/checkout"]');
    if(t) vasarlasJel();
  }, true);
  function masAblakNyitva(){
    return document.documentElement.classList.contains('open-modal')
      || !!document.querySelector('.modal.active, .mvt-ajanlat--lathato');
  }

  /* NAPI KORLÁT — a popup egy látogatónak naponta legfeljebb egyszer jöhet elő.
     A jelet a megnyitás pillanatában tesszük le (nem a bezáráskor), így az sem
     kapja újra, aki csak elnavigál róla. A téma saját sütijét használjuk:
     a `newsletter_popup_hidden` a téma auto-triggerét (görgetés, tétlenség) is
     blokkolja (section-newsletter-popup.js → shouldBlockPopupAutoTrigger), és
     a lenti kihagyjuk() eleve nézi. A téma maga is 1 napra teszi le. */

  function sutiVan(nev){
    return document.cookie.split('; ').some(function(c){ return c.indexOf(nev+'=')===0; });
  }
  /* A rendelési folyamatban nem ugorhat fel: kosár, a sajat penztar nezet
     (/cart?view=penztar), a kosR proxy oldala es a Shopify checkout. */
  function rendelesiFolyamat(){
    var p=location.pathname;
    if(p.charAt(p.length-1)==='/') p=p.slice(0,-1);
    var utolso=p.split('/').pop();
    return utolso==='cart' || p.indexOf('/checkouts')>=0 || p.indexOf('/apps/checkout')>=0;
  }

  function kihagyjuk(){
    if(landingOldal) return true;                                        // /pages/kviz: ott nem kell popup
    if(vasarol) return true;                                             // kosárba tett: ne álljunk az útjába
    if(rendelesiFolyamat()) return true;                                 // kosár / pénztár / fizetés
    if(location.search.indexOf('customer_posted=true')>=0) return true;   // beküldés után az eredmény jön
    if(sutiVan('newsletter_popup_success')) return true;                 // feliratkozott: a téma saját jelzése
    var kapu = popupKapu();
    if(!kapu){                                                           // az app embed nincs bekapcsolva
      if(!window.mvtPopupKapuHiany){
        window.mvtPopupKapuHiany = true;
        console.warn('MOVTECH: a popup-szabályok (MOVTECH ajánlatok app) nem töltődtek be, ezért a kvíz popup nem jelenik meg.');
      }
      return true;
    }
    /* A két tartós tiltó okot (kitöltötte / betelt a napi keret) a téma nyelvén is
       kimondjuk, mert a téma saját görgetés-triggere csak a sütiket nézi. Enélkül
       az app szabálya kimarad, és a popup a kitöltőnek is felugrik. Aki korábban
       töltötte ki, az ezt a sütit az első oldalbetöltésnél visszamenőleg megkapja. */
    var okAllapot = kapu.allapot ? kapu.allapot() : null;
    if(okAllapot && okAllapot.kesz && okAllapot.kesz.kviz){
      temaTriggerTiltas(true);
      return true;
    }
    if(okAllapot && okAllapot.db >= okAllapot.napi_max){
      temaTriggerTiltas(false);
      return true;
    }
    return !kapu.szabad('kviz');
  }

  /* A téma a hírlevél-popup szekció JS-ét csak interakcióra tölti be. */
  var temaJsKerve=false;
  function temaJsBetolt(){
    if(temaJsKerve || customElements.get('newsletter-popup')) return;
    var sc=document.querySelector('script[data-kviz-popup-js]');
    var url=sc && sc.getAttribute('data-kviz-popup-js');
    if(!url) return;
    temaJsKerve=true;
    var uj=document.createElement('script');
    uj.type='module'; uj.src=url;
    document.head.appendChild(uj);
  }

  function felepit(){
    var tpl=kvizSablon();
    if(!tpl || !tpl.parentNode) return document.querySelector('newsletter-popup');
    tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl);
    tpl.parentNode.removeChild(tpl);                 // a téma ne építse fel másodszor
    mvtKartyaRajzol();                               // az utalványkép canvasra (LCP)
    return document.querySelector('newsletter-popup');
  }

  var elem=null;
  function elokeszit(){
    if(elem || kihagyjuk()) return;
    elem = document.querySelector('newsletter-popup') || felepit();
    if(!elem) return;
    temaJsBetolt();
    var kiserlet=0;
    var ora=setInterval(function(){
      if(typeof elem.createPopup==='function'){
        elem.scrollTriggered=true;                   // a téma görgetés-triggere ne nyissa meg helyettünk
        elem._inactivityInitialized=true;
        elem._inactivityTriggered=true;
        if(elem.modal){ clearInterval(ora); return; }
      }
      if(++kiserlet>80) clearInterval(ora);
    }, 100);
  }

  /* Analitika: a téma a bezáráskor leveszi az active osztályt a modalról (X gomb,
     háttér, Esc egyaránt), ezt figyeljük, hogy mindegy legyen, mivel zárta be. */
  function bezarasFigyel(){
    var probak=0;
    var ora=setInterval(function(){
      var m=document.querySelector('newsletter-modal-popup');
      if(!m || !m.classList.contains('active')){ if(++probak>30) clearInterval(ora); return; }
      clearInterval(ora);
      var figyelo=new MutationObserver(function(){
        if(m.classList.contains('active')) return;
        figyelo.disconnect();
        kvizMeres('bezaras', {fazis:kvizAktFazis, lepes:kvizMaxLepes});
      });
      figyelo.observe(m, {attributes:true, attributeFilter:['class']});
    }, 100);
  }

  /* SÜTI-ABLAK ELŐBB (2026-10-08, Lexi kérése): a kvíz nem nyílhat a Shopify süti-ablaka
     fölé. Amíg a sáv vagy a „Beállítások kezelése” ablak látszik, várunk; ha eltűnt
     (elfogadta, elutasította, elmentette vagy bezárta), SUTI_UTAN mp múlva nyitunk.
     A láthatóságot nézzük, nem a Shopify API-t: a shouldShowBanner() döntés után is igazat ad.
     Ha a sáv még meg sem jelent (lassú betöltés), de a látogató még nem döntött, legfeljebb
     SUTI_VAR ideig várunk rá. */
  var SUTI_UTAN = 2000, SUTI_VAR = 10000, sutiVaras = false, sutiVarasKezdet = 0;
  function sutiAblakNyitva(){
    var elemek = document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs__dialog');
    for(var i=0;i<elemek.length;i++){ var r = elemek[i].getBoundingClientRect(); if(r.width > 0 && r.height > 0) return true; }
    if(!elemek.length){                                  // a sáv még nincs a lapon: jön még?
      try{
        var cp = window.Shopify && window.Shopify.customerPrivacy, d = cp && cp.currentVisitorConsent && cp.currentVisitorConsent();
        var donteletlen = d && !d.marketing && !d.analytics && !d.preferences;
        if(cp && cp.shouldShowBanner && cp.shouldShowBanner() && donteletlen){
          if(!sutiVarasKezdet) sutiVarasKezdet = Date.now();
          return Date.now() - sutiVarasKezdet < SUTI_VAR;
        }
      }catch(e){}
    }
    return false;
  }
  function sutiUtanNyit(){
    if(sutiVaras) return;
    sutiVaras = true;
    var ora = setInterval(function(){
      if(sutiAblakNyitva()) return;
      clearInterval(ora); sutiVaras = false;
      setTimeout(function(){ nyit(0); }, SUTI_UTAN);
    }, 500);
  }

  function nyit(probak){
    if(kihagyjuk()) return;
    if(sutiAblakNyitva()){ sutiUtanNyit(); return; }     // előbb a süti-ablak
    if(document.hidden){                             // háttérben lévő fül: megvárjuk, míg előjön
      document.addEventListener('visibilitychange', function ujra(){
        document.removeEventListener('visibilitychange', ujra);
        setTimeout(function(){ nyit(0); }, 1500);
      });
      return;
    }
    if(masAblakNyitva()){                                            // más ablak van nyitva
      if((probak||0) < 5) setTimeout(function(){ nyit((probak||0)+1); }, UJRAPROBA);
      return;
    }
    elokeszit();
    if(!elem) return;
    var kiserlet=0;
    var ora=setInterval(function(){
      if(typeof elem.createPopup==='function' && elem.modal){
        clearInterval(ora);
        if(vasarol || masAblakNyitva()) return;      // az előkészítés alatt kosárba tett / más ablak nyílt
        if(sutiAblakNyitva()){ sutiUtanNyit(); return; }   // közben jött fel a süti-ablak
        var kapu = popupKapu();
        if(kapu) kapu.megjelent('kviz');            // a napi korlátot az app tartja számon
        elem.createPopup();
        kvizMeres('megjelenes', {kesleltetes_mp: Math.round(((window.performance && performance.now) ? performance.now() : 0)/1000)});
        bezarasFigyel();
      }
      else if(++kiserlet>60) clearInterval(ora);
    }, 100);
  }

  if(!kvizSablon() && !document.querySelector('newsletter-popup')) return;  // ezen az oldalon nincs popup
  if(kihagyjuk()) return;
  var eltelt = (window.performance && performance.now) ? performance.now() : 0;
  setTimeout(elokeszit, Math.max(0, ELOKESZITES - eltelt));
  setTimeout(function(){ nyit(0); }, Math.max(300, IDO - eltelt));
})();

/* ============================================================
   AJÁNDÉKUTALVÁNY CANVASRA (2026-10-08)
   A snippets/movtech-kartya.liquid <canvas data-kep>-et ad ki <img> helyett: a 7 mp
   után nyíló popup képe különben a termékképnél nagyobbnak számított, és a Google
   mérésében (LCP) ez lett az oldal fő tartalma, 20+ mp-es értékkel. A canvast az LCP
   nem számolja. Ez a függvény rajzolja rá a képet, ahol a kártya megjelenik:
   a popup felépítésekor, a téma saját nyitásakor, az utólagos rétegben és a /pages/kviz-en.
   ============================================================ */
function mvtKartyaRajzol(gyoker){
  var vasznak=(gyoker||document).querySelectorAll('canvas.mvt-kartya-kep[data-kep]:not([data-kesz])');
  for(var i=0;i<vasznak.length;i++){
    (function(v){
      v.setAttribute('data-kesz','1');
      var k=new Image();
      k.onload=function(){ try{ v.getContext('2d').drawImage(k,0,0,v.width,v.height); }catch(e){} };
      k.src=v.getAttribute('data-kep');
    })(vasznak[i]);
  }
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ mvtKartyaRajzol(); });
else mvtKartyaRajzol();
document.addEventListener('modal:opened',function(){ mvtKartyaRajzol(); });



